const calculators = [
  {
      "name": "ECG: Heart Rate",
      "id": "calculator_1",
      "description": null,
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "ECG",
          "Heart Rate",
          "ekg",
          "cardiology",
          "emergency",
          "er"
      ]
  },
  {
      "name": "Glomerulosclerosis on Biopsy (2015)",
      "id": "calculator_2",
      "description": "Differentiate glomerulosclerosis from kidney disease rather than aging",
      "categories": [
          "Nephrology",
          "Pathology & Lab Medicine"
      ],
      "tags": [
          "nephrology",
          "glomerulosclerosis",
          "ckd",
          "biopsy",
          "kidney",
          "glomerulus",
          "glomeruli",
          "pathology"
      ]
  },
  {
      "name": "ROKS - Recurrence Of Kidney Stone (2014)",
      "id": "calculator_3",
      "description": "Predict risk of recurrent kidney stones",
      "categories": [
          "Nephrology",
          "Urology"
      ],
      "tags": [
          "nephrology",
          "urology",
          "Nephrolithiasis",
          "Stone",
          "calcium",
          "oxalate",
          "struvite",
          "cysteine",
          "cystine",
          "ESWL",
          "lithotripsy"
      ]
  },
  {
      "name": "Solitary Pulmonary Nodule Malignancy Risk",
      "id": "calculator_4",
      "description": "Workup a solitary pulmonary nodule",
      "categories": [
          "Respirology"
      ],
      "tags": [
          "Solitary",
          "Pulmonary",
          "Nodule",
          "Malignancy",
          "Risk",
          "lung",
          "cancer",
          "respirology"
      ]
  },
  {
      "name": "A-a Gradient",
      "id": "calculator_5",
      "description": "Used to determine cause of hypoxemia",
      "categories": [
          "Emergency",
          "Respirology",
          "Critical Care"
      ],
      "tags": [
          "emergency",
          "er",
          "respirology",
          "Aa",
          "a",
          "Gradient",
          "alveolar",
          "FiO2",
          "PaCO2",
          "PaO2",
          "respiratory quotient"
      ]
  },
  {
      "name": "ABCD² Score",
      "id": "calculator_6",
      "description": "Guide admission in TIA based on ABCD² Score",
      "categories": [
          "Neurology / Neurosurgery",
          "Geriatrics"
      ],
      "tags": [
          "ABCD2",
          "Score",
          "tia",
          "stroke",
          "cva",
          "diabetes",
          "admission",
          "johnston",
          "rothwell",
          "neurology"
      ]
  },
  {
      "name": "Access Recirculation",
      "id": "calculator_7",
      "description": "Calculate dialysis access recirculation",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "Access",
          "Recirculation",
          "vascular",
          "AVF",
          "fistula",
          "graft",
          "AVG",
          "dialysis"
      ]
  },
  {
      "name": "Infarct Size - Anterior",
      "id": "calculator_9",
      "description": "Estimate infarct size in anterior MI",
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "cardiology",
          "emergency",
          "er",
          "Infarct Size",
          "Anterior",
          "MI",
          "myocardial",
          "infarction",
          "ACS"
      ]
  },
  {
      "name": "Infarct Size - Inferior",
      "id": "calculator_10",
      "description": "Estimate infarct size in inferior MI",
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "cardiology",
          "emergency",
          "er",
          "MI",
          "myocardial",
          "infarction",
          "ACS",
          "Infarct",
          "size",
          "Inferior"
      ]
  },
  {
      "name": "Anion Gap",
      "id": "calculator_11",
      "description": "Calculate anion gap for workup of acid-base disorders",
      "categories": [
          "Emergency",
          "Nephrology"
      ],
      "tags": [
          "emergency",
          "er",
          "nephrology",
          "Anion",
          "Gap",
          "acidosis",
          "hyperchloremic",
          "electrolyte"
      ]
  },
  {
      "name": "APACHE II",
      "id": "calculator_12",
      "description": "Estimate mortality in the critically ill",
      "categories": [
          "Nephrology",
          "Gastroenterology",
          "Critical Care",
          "Anesthesiology"
      ],
      "tags": [
          "APACHE",
          "II",
          "2",
          "ICU",
          "critical",
          "care",
          "prognosis",
          "mortality",
          "knaus",
          "gi",
          "gastroenterology"
      ]
  },
  {
      "name": "APGAR",
      "id": "calculator_13",
      "description": "Rapid newborn clinical assessment",
      "categories": [
          "Emergency",
          "Pediatrics"
      ],
      "tags": [
          "emergency",
          "er",
          "pediatrics",
          "APGAR",
          "pediatric",
          "neonate",
          "newborn"
      ]
  },
  {
      "name": "AR: Quantification (Volumetric)",
      "id": "calculator_14",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "AR",
          "Quantification",
          "Volumetric",
          "aortic",
          "regurgitation",
          "echo",
          "echocardiogram"
      ]
  },
  {
      "name": "AR: Regurgitant Orifice (PISA)",
      "id": "calculator_15",
      "description": "Measure effective regurgitant orifice by PISA",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "AR",
          "aortic",
          "regurgitation",
          "echo",
          "echocardiogram",
          "Regurgitant",
          "Orifice",
          "PISA"
      ]
  },
  {
      "name": "AS: Aortic Valve Area (Cont)",
      "id": "calculator_16",
      "description": "Estimate aortic valve area",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "aortic",
          "echo",
          "echocardiogram",
          "AS",
          "Valve",
          "Area",
          "Cont",
          "stenosis"
      ]
  },
  {
      "name": "AS: Aortic Valve Area (DVI)",
      "id": "calculator_17",
      "description": "Estimate aortic valve area",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "aortic",
          "echo",
          "echocardiogram",
          "AS",
          "Valve",
          "Area",
          "stenosis",
          "DVI"
      ]
  },
  {
      "name": "AS: Aortic Valve Area (Gorlin)",
      "id": "calculator_18",
      "description": "Estimate aortic valve area",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "aortic",
          "echo",
          "echocardiogram",
          "AS",
          "Valve",
          "Area",
          "stenosis",
          "Gorlin"
      ]
  },
  {
      "name": "AS: Aortic Valve Area (Hakki)",
      "id": "calculator_19",
      "description": "Estimate aortic valve area",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "aortic",
          "echo",
          "echocardiogram",
          "AS",
          "Valve",
          "Area",
          "stenosis",
          "Hakki"
      ]
  },
  {
      "name": "Autoimmune Hepatitis Diagnosis",
      "id": "calculator_20",
      "description": "Clarify the diagnose of autoimmune hepatitis",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "gi",
          "gastroenterology",
          "Autoimmune",
          "Hepatitis",
          "Diagnosis",
          "alp",
          "phos",
          "sma",
          "ana",
          "lkm",
          "smooth",
          "muscle",
          "liver",
          "cirrhosis",
          "aih"
      ]
  },
  {
      "name": "AVM Rupture Risk",
      "id": "calculator_21",
      "description": "Estimate risk of rupture of an arteriovenous malformation (AVM)",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "Risk",
          "stroke",
          "cva",
          "neurology",
          "AVM",
          "Rupture",
          "arteriovenous",
          "malformation"
      ]
  },
  {
      "name": "Surgery in Asymptomatic Aortic Stenosis",
      "id": "calculator_22",
      "description": "Assess timing of surgery in severe, asymptomatic aortic stenosis",
      "categories": [
          "Cardiology",
          "Cardiac Surgery"
      ],
      "tags": [
          "cardiology",
          "aortic",
          "echo",
          "echocardiogram",
          "AS",
          "stenosis",
          "Asymptomatic",
          "Surgery",
          "Timing",
          "BNP"
      ]
  },
  {
      "name": "British Columbia PCI risk score",
      "id": "calculator_23",
      "description": "Estimate 30-day mortality after percutaneous coronary intervention",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "Score",
          "mortality",
          "PCI",
          "Canada",
          "CAD",
          "percutaneous",
          "coronary",
          "intervention",
          "angiogram",
          "stent"
      ]
  },
  {
      "name": "Bishop Score",
      "id": "calculator_24",
      "description": "Predict whether induction of labor will be required.",
      "categories": [
          "Obstetrics & Gynecology"
      ],
      "tags": [
          "Score",
          "Bishop",
          "delivery",
          "cervix",
          "cervical",
          "station",
          "preeclampsia",
          "pre",
          "eclampsia",
          "PET",
          "PPROM",
          "labor",
          "labour",
          "fetal",
          "fetus",
          "nulliparity",
          "nulliparous",
          "induction",
          "pelvic",
          "pregnancy"
      ]
  },
  {
      "name": "Blatchford Score",
      "id": "calculator_25",
      "description": "Assess if intervention is required for acute upper GI bleeding.",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "Score",
          "admission",
          "gi",
          "gastroenterology",
          "Blatchford",
          "Bleed",
          "endoscopy",
          "gastrointestinal"
      ]
  },
  {
      "name": "Bleeding Risk in Atrial Fibrillation: OBRI",
      "id": "calculator_26",
      "description": "The Outpatient Bleeding Risk Index (OBRI) estimates risk of bleeding in AF while on oral anticoagulation.",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "Risk",
          "Warfarin",
          "Bleeding",
          "OBRI",
          "atrial",
          "fibrillation",
          "Afib",
          "AF"
      ]
  },
  {
      "name": "BMI and BSA (Mosteller)",
      "id": "calculator_28",
      "description": "Calculate BMI and Body Surface Area using Mosteller formula",
      "categories": [
          "General Calculators",
          "Hematology",
          "Oncology",
          "Anesthesiology"
      ],
      "tags": [
          "Area",
          "body",
          "mass",
          "index",
          "surface",
          "dosing",
          "bmi",
          "bsa",
          "hematology",
          "heme",
          "oncology"
      ]
  },
  {
      "name": "BODE Index for COPD",
      "id": "calculator_29",
      "description": "Estimate prognosis in COPD",
      "categories": [
          "Respirology"
      ],
      "tags": [
          "Pulmonary",
          "respirology",
          "index",
          "BODE",
          "COPD",
          "Chronic",
          "Obstructive",
          "Disease"
      ]
  },
  {
      "name": "BMI and BSA (Du Bois)",
      "id": "calculator_30",
      "description": "Determine body mass index and body surface area using Du Bois method",
      "categories": [
          "General Calculators",
          "Hematology",
          "Oncology",
          "Anesthesiology"
      ],
      "tags": [
          "Area",
          "body",
          "mass",
          "index",
          "surface",
          "dosing",
          "bmi",
          "bsa",
          "hematology",
          "heme",
          "oncology"
      ]
  },
  {
      "name": "Pretest Probablity of CAD",
      "id": "calculator_32",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "CAD",
          "coronary",
          "Disease",
          "Pretest",
          "Probablity",
          "artery",
          "GXT",
          "stress",
          "test"
      ]
  },
  {
      "name": "Canadian CT Head Rule",
      "id": "calculator_33",
      "description": "Determine which minor head injury patients need head CT imaging",
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery",
          "Orthopedics",
          "Surgery",
          "Critical Care",
          "Medical Imaging"
      ],
      "tags": [
          "emergency",
          "er",
          "Rule",
          "Canadian",
          "CT",
          "Head",
          "GCS",
          "fracture",
          "skull",
          "xray",
          "x",
          "ray",
          "amnesia",
          "trauma",
          "new",
          "orleans",
          "orthopedics"
      ]
  },
  {
      "name": "Canadian C-Spine Rule",
      "id": "calculator_34",
      "description": "Determine whether cervical spine imaging can be safely avoided",
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery",
          "Orthopedics",
          "Medical Imaging"
      ],
      "tags": [
          "emergency",
          "er",
          "cervical",
          "Rule",
          "Canadian",
          "fracture",
          "xray",
          "x",
          "ray",
          "trauma",
          "orthopedics",
          "C",
          "Spine",
          "MVA",
          "MVC",
          "neck",
          "NEXUS"
      ]
  },
  {
      "name": "HEART Score | Chest pain in the ER",
      "id": "calculator_35",
      "description": "Risk stratify patients with chest pain in the ER",
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "cardiology",
          "emergency",
          "er",
          "Score",
          "MI",
          "HEART",
          "Chest",
          "pain",
          "ED"
      ]
  },
  {
      "name": "BC Cardiac Surgical Intensive Care Score",
      "id": "calculator_36",
      "description": "Predict mortality after cardiac surgery based on preoperative and intraoperative variables assessed at admission to a cardiac surgery ICU",
      "categories": [
          "Cardiology",
          "Cardiac Surgery"
      ],
      "tags": [
          "cardiology",
          "Score",
          "mortality",
          "aortic",
          "BC",
          "Cardiac",
          "Surgical",
          "Intensive Care",
          "CSICU",
          "Ascending",
          "Procedure",
          "CABG",
          "Valves"
      ]
  },
  {
      "name": "ACC/AHA CV Risk Calculator (2013)",
      "id": "calculator_37",
      "description": "Estimate 10-year risk for atherosclerotic cardiovascular disease",
      "categories": [
          "Cardiology",
          "Preventive Medicine",
          "Anesthesiology",
          "Geriatrics"
      ],
      "tags": [
          "cardiology",
          "Risk",
          "diabetes",
          "ascvd",
          "lipid",
          "cv",
          "cardiovascular",
          "acc",
          "aha"
      ]
  },
  {
      "name": "CHADS2 Score for Atrial Fibrillation",
      "id": "calculator_40",
      "description": "Assess risk of stroke in atrial fibrillation",
      "categories": [
          "Cardiology",
          "Emergency",
          "Neurology / Neurosurgery",
          "Geriatrics"
      ],
      "tags": [
          "cardiology",
          "emergency",
          "er",
          "Score",
          "tia",
          "stroke",
          "cva",
          "neurology",
          "Warfarin",
          "atrial",
          "fibrillation",
          "Afib",
          "AF",
          "CHADS2",
          "coumadin",
          "prevention"
      ]
  },
  {
      "name": "CHA2DS2-VASc Score for AF",
      "id": "calculator_41",
      "description": "Replacement for CHADS2 for stroke prediction in atrial fibrillation",
      "categories": [
          "Cardiology",
          "Emergency",
          "Neurology / Neurosurgery",
          "Geriatrics"
      ],
      "tags": [
          "cardiology",
          "emergency",
          "er",
          "Score",
          "tia",
          "stroke",
          "cva",
          "neurology",
          "Warfarin",
          "atrial",
          "fibrillation",
          "Afib",
          "AF",
          "coumadin",
          "prevention",
          "CHA2DS2",
          "VASc",
          "CHA2DS2VASc"
      ]
  },
  {
      "name": "Framingham CHF Criteria",
      "id": "calculator_42",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "HEART",
          "Framingham",
          "CHF",
          "Criteria",
          "failure"
      ]
  },
  {
      "name": "Child Pugh Score",
      "id": "calculator_43",
      "description": "Determine severity and estimate mortality in cirrhosis",
      "categories": [
          "Emergency",
          "Infectious Disease",
          "Gastroenterology",
          "Critical Care"
      ],
      "tags": [
          "emergency",
          "er",
          "Score",
          "prognosis",
          "gi",
          "gastroenterology",
          "liver",
          "cirrhosis",
          "MELD",
          "Child",
          "Pugh",
          "ascites",
          "encephalopathy"
      ]
  },
  {
      "name": "CMML Prognostic Scoring Systems (from Spain and Dusseldorf)",
      "id": "calculator_45",
      "description": "Assess risk of progression to AML and early mortality in CMML",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "hematology",
          "heme",
          "oncology",
          "Chronic",
          "CMML",
          "Prognostic",
          "Scoring",
          "Systems",
          "Spain",
          "Dusseldorf",
          "Myelomonocytic",
          "Leukemia"
      ]
  },
  {
      "name": "Contrast Nephropathy Post-PCI",
      "id": "calculator_47",
      "description": "Estimate risk of AKI after percutaneous coronary intervention",
      "categories": [
          "Nephrology",
          "Critical Care"
      ],
      "tags": [
          "nephrology",
          "PCI",
          "failure",
          "eGFR",
          "Contrast",
          "Nephropathy",
          "Post",
          "CIN",
          "AKI",
          "acute",
          "renal"
      ]
  },
  {
      "name": "ECG: Corrected QT",
      "id": "calculator_48",
      "description": "Calculate the corrected QT interval",
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "ECG",
          "ekg",
          "cardiology",
          "emergency",
          "er",
          "Corrected",
          "QT"
      ]
  },
  {
      "name": "Corticosteroid Equivalence",
      "id": "calculator_49",
      "description": "Determine equivalent dosage of corticosteroid",
      "categories": [
          "Respirology"
      ],
      "tags": [
          "respirology",
          "Corticosteroid",
          "Equivalence",
          "steroid",
          "dex",
          "dexamethason",
          "glucocorticoid",
          "prednisone",
          "methylprednisolone",
          "cortisone",
          "hydrocortisone"
      ]
  },
  {
      "name": "Cerebral Perfusion Pressure",
      "id": "calculator_50",
      "description": "Calculate net pressure gradient causing cerebral blood flow to the brain",
      "categories": [
          "Neurology / Neurosurgery",
          "Critical Care"
      ],
      "tags": [
          "neurology",
          "Cerebral",
          "Perfusion",
          "Pressure",
          "CPP",
          "MAP",
          "ICP"
      ]
  },
  {
      "name": "CrCl Cockroft-Gault",
      "id": "calculator_51",
      "description": "Estimate creatinine clearance",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "GFR",
          "creatinine",
          "clearance",
          "glomerular",
          "filtration",
          "rate",
          "CrCl",
          "CockroftGault",
          "Cockroft",
          "Gault"
      ]
  },
  {
      "name": "CrCl from 24h Urine",
      "id": "calculator_52",
      "description": "Calculate creatinine clearance from a 24h urine collection.",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "GFR",
          "creatinine",
          "clearance",
          "glomerular",
          "filtration",
          "rate",
          "CrCl",
          "from",
          "24h",
          "Urine",
          "24",
          "hour"
      ]
  },
  {
      "name": "CRUSADE Score for Post-MI Bleeding Risk",
      "id": "calculator_53",
      "description": "Estimate bleeding risk after NSTEMI.\r\n",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "Score",
          "MI",
          "ACS",
          "Bleeding",
          "hemorrhage",
          "Crusade",
          "NSTEMI"
      ]
  },
  {
      "name": "CT Severity Index (Pancreatitis)",
      "id": "calculator_54",
      "description": "Predict complication and mortality rate in pancreatitis, based on CT findings (Balthazar score)",
      "categories": [
          "Gastroenterology",
          "Medical Imaging"
      ],
      "tags": [
          "Severity",
          "prognosis",
          "gi",
          "gastroenterology",
          "index",
          "CT",
          "pancreatitis",
          "pancreas",
          "Balthazar"
      ]
  },
  {
      "name": "ECG: Cycle Length",
      "id": "calculator_56",
      "description": null,
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "ECG",
          "ekg",
          "cardiology",
          "emergency",
          "er",
          "Cycle",
          "Length"
      ]
  },
  {
      "name": "Dialysis Risk After Cardiac Surgery (Mehta)",
      "id": "calculator_62",
      "description": "Estimate the risk of dialysis after cardiac surgery (Mehta model)",
      "categories": [
          "Cardiology",
          "Nephrology",
          "Cardiac Surgery",
          "Critical Care",
          "Anesthesiology"
      ],
      "tags": [
          "emergency",
          "er",
          "nephrology",
          "Risk",
          "dialysis",
          "Surgery",
          "Cardiac",
          "cardiovascular",
          "failure",
          "Post",
          "AKI",
          "acute",
          "renal",
          "mehta"
      ]
  },
  {
      "name": "Discriminant Function (Alcoholic Hepatitis)",
      "id": "calculator_63",
      "description": null,
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "gi",
          "gastroenterology",
          "Hepatitis",
          "prednisone",
          "Discriminant",
          "Function",
          "alcoholic",
          "pentoxyfilline"
      ]
  },
  {
      "name": "Diffuse Large B-Cell Lymphoma Prognosis (R-IPI)",
      "id": "calculator_64",
      "description": "Determine prognosis in diffuse large B-cell lymphoma",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "prognosis",
          "index",
          "hematology",
          "heme",
          "oncology",
          "Prognostic",
          "DLBCL",
          "R",
          "IPI",
          "RIPI",
          "International",
          "revised",
          "rituximab",
          "diffuse",
          "large",
          "b",
          "cell",
          "lymphoma"
      ]
  },
  {
      "name": "Dubbo Osteoporotic Fracture Risk",
      "id": "calculator_66",
      "description": "Assess risk of osteoporotic fracture",
      "categories": [
          "Endocrinology",
          "Geriatrics"
      ],
      "tags": [
          "Risk",
          "Score",
          "fracture",
          "Dubbo",
          "Osteoporotic",
          "osteoporosis",
          "endocrinology",
          "t-score"
      ]
  },
  {
      "name": "Duke Criteria for Endocarditis",
      "id": "calculator_67",
      "description": "Diagnose endocarditis",
      "categories": [
          "Cardiology",
          "Infectious Disease"
      ],
      "tags": [
          "cardiology",
          "Criteria",
          "Duke",
          "Endocarditis",
          "SBE",
          "IE"
      ]
  },
  {
      "name": "Duke Treadmill Score",
      "id": "calculator_68",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "Score",
          "Angina",
          "Duke",
          "Treadmill",
          "ST"
      ]
  },
  {
      "name": "DVT Clinical Probability (Well's)",
      "id": "calculator_69",
      "description": "Determine pretest probability of DVT to guide workup",
      "categories": [
          "Emergency",
          "Urology",
          "Respirology",
          "Hematology",
          "Orthopedics",
          "Critical Care",
          "Medical Imaging"
      ],
      "tags": [
          "emergency",
          "er",
          "Pulmonary",
          "respirology",
          "hematology",
          "heme",
          "oncology",
          "orthopedics",
          "DVT",
          "Clinical",
          "Probability",
          "deep",
          "vein",
          "thrombosis",
          "PE",
          "embolism",
          "wells",
          "d",
          "dimer"
      ]
  },
  {
      "name": "Syncope - EGSYS Score",
      "id": "calculator_70",
      "description": "Which patients with syncope should be admitted?",
      "categories": [
          "Cardiology",
          "Geriatrics"
      ],
      "tags": [
          "cardiology",
          "Score",
          "Syncope",
          "EGSYS"
      ]
  },
  {
      "name": "Ejection Fraction (Simplified)",
      "id": "calculator_71",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "Ejection",
          "Fraction",
          "Simplified",
          "EF"
      ]
  },
  {
      "name": "Emory Model (TIPSS)",
      "id": "calculator_72",
      "description": null,
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "gi",
          "gastroenterology",
          "liver",
          "cirrhosis",
          "Emory",
          "Model",
          "TIPSS",
          "MELD",
          "Child",
          "Pugh"
      ]
  },
  {
      "name": "Lund-Mackay Sinusitis Stage",
      "id": "calculator_75",
      "description": "Assess severity of chronic rhinosinusitis and assess response to therapy",
      "categories": [
          "Infectious Disease",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Chronic",
          "ent",
          "ear",
          "nose",
          "throat",
          "Lund",
          "Mackay",
          "Sinusitis",
          "Stage",
          "rhinosinusitis"
      ]
  },
  {
      "name": "Mucosal Melanoma",
      "id": "calculator_77",
      "description": null,
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "cancer",
          "ent",
          "ear",
          "nose",
          "throat",
          "TNM",
          "staging",
          "Mucosal",
          "Melanoma"
      ]
  },
  {
      "name": "Epworth Sleepiness Scale",
      "id": "calculator_85",
      "description": "Screen for excessive sleepiness or follow response to treatment for a sleep disorder",
      "categories": [
          "Respirology"
      ],
      "tags": [
          "respirology",
          "Obstructive",
          "Epworth",
          "Sleepiness",
          "Scale",
          "OSA",
          "apnea",
          "sleep"
      ]
  },
  {
      "name": "Pulmonary Embolism Severity Index (PESI)",
      "id": "calculator_86",
      "description": "Predict outcome in patients with pulmonary embolism",
      "categories": [
          "Emergency",
          "Urology",
          "Respirology",
          "Hematology",
          "Orthopedics",
          "Critical Care"
      ],
      "tags": [
          "emergency",
          "er",
          "Pulmonary",
          "respirology",
          "Severity",
          "index",
          "hematology",
          "heme",
          "orthopedics",
          "DVT",
          "PE",
          "embolism",
          "PESI"
      ]
  },
  {
      "name": "Exercise Capacity (METs)",
      "id": "calculator_88",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "exercise",
          "capacity",
          "mets"
      ]
  },
  {
      "name": "SAH Fisher Grade",
      "id": "calculator_89",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "neurology",
          "hemorrhage",
          "SAH",
          "Fisher",
          "Grade",
          "subarachnoid",
          "vasospasm"
      ]
  },
  {
      "name": "Follicular Lymphoma prognosis",
      "id": "calculator_90",
      "description": "Determine prognosis in follicular lymphoma (FLIPI)",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "prognosis",
          "hematology",
          "heme",
          "oncology",
          "lymphoma",
          "Follicular"
      ]
  },
  {
      "name": "Forrester HF Class",
      "id": "calculator_91",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "HEART",
          "Class",
          "forrester",
          "hf",
          "failure, CHF"
      ]
  },
  {
      "name": "Forrest Classification",
      "id": "calculator_92",
      "description": "Estimate risk of re-bleeding post-endoscopy for upper GI bleeding.",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "gi",
          "gastroenterology",
          "Bleed",
          "gastrointestinal",
          "Forrest",
          "Classification",
          "PUD",
          "rebleed"
      ]
  },
  {
      "name": "Fosphenytoin Load",
      "id": "calculator_93",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "neurology",
          "Fosphenytoin",
          "Load",
          "seizure"
      ]
  },
  {
      "name": "FOUR Score",
      "id": "calculator_94",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery",
          "Critical Care"
      ],
      "tags": [
          "Score",
          "neurology",
          "GCS",
          "FOUR",
          "4",
          "coma",
          "wijdicks"
      ]
  },
  {
      "name": "Fractional Shortening",
      "id": "calculator_95",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "Fractional",
          "Shortening"
      ]
  },
  {
      "name": "Fractional Excretion of Sodium",
      "id": "calculator_96",
      "description": "Differentiate pre-renal AKI from ATN.",
      "categories": [
          "Emergency",
          "Nephrology",
          "Critical Care"
      ],
      "tags": [
          "emergency",
          "er",
          "nephrology",
          "failure",
          "creatinine",
          "AKI",
          "acute",
          "renal",
          "Fractional",
          "Excretion",
          "Sodium",
          "na"
      ]
  },
  {
      "name": "Fractional Excretion of Urea",
      "id": "calculator_97",
      "description": "Identify a pre-renal state in patients using diuretics",
      "categories": [
          "Nephrology",
          "Critical Care"
      ],
      "tags": [
          "nephrology",
          "failure",
          "creatinine",
          "AKI",
          "acute",
          "renal",
          "Fractional",
          "Excretion",
          "urea"
      ]
  },
  {
      "name": "Lipid Lowering Guidelines using Framingham (2008)",
      "id": "calculator_98",
      "description": null,
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "cardiology",
          "stroke",
          "cva",
          "prognosis",
          "CAD",
          "Cardiac",
          "lipid",
          "Framingham",
          "CHF",
          "using",
          "Lowering",
          "Guidelines",
          "2008",
          "CVD"
      ]
  },
  {
      "name": "Lipid Lowering Guidelines using Framingham (ATP-III)",
      "id": "calculator_99",
      "description": null,
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "cardiology",
          "stroke",
          "cva",
          "prognosis",
          "CAD",
          "Cardiac",
          "lipid",
          "Framingham",
          "CHF",
          "Lowering",
          "Guidelines",
          "CVD",
          "ATP",
          "3",
          "III"
      ]
  },
  {
      "name": "Mortality in IPF (GAP Index)",
      "id": "calculator_100",
      "description": "Estimate mortality in idiopathic pulmonary fibrosis",
      "categories": [
          "Respirology"
      ],
      "tags": [
          "respirology",
          "Gap",
          "mortality",
          "index",
          "IPF"
      ]
  },
  {
      "name": "Glasgow Coma Scale (GCS)",
      "id": "calculator_101",
      "description": "Document level of consciousness.",
      "categories": [
          "Neurology / Neurosurgery",
          "Surgery",
          "Critical Care",
          "Anesthesiology"
      ],
      "tags": [
          "neurology",
          "GCS",
          "Scale",
          "FOUR",
          "4",
          "coma",
          "Glasgow"
      ]
  },
  {
      "name": "Renal Graft Failure at 5-Years, Predicted 1 Year Post Transplant",
      "id": "calculator_102",
      "description": "Estimate the risk of kidney transplant graft failure at 5 years",
      "categories": [
          "Nephrology",
          "Transplant"
      ],
      "tags": [
          "nephrology",
          "Risk",
          "graft",
          "failure",
          "Post",
          "renal",
          "5",
          "Years",
          "Predicted",
          "1",
          "Transplant",
          "rejection"
      ]
  },
  {
      "name": "Renal Graft Failure at 5-Years, Predicted 7 Days Post Transplant",
      "id": "calculator_103",
      "description": "Estimate the risk of kidney transplant graft failure at 5 years",
      "categories": [
          "Nephrology",
          "Transplant"
      ],
      "tags": [
          "nephrology",
          "Risk",
          "graft",
          "failure",
          "Post",
          "renal",
          "5",
          "Years",
          "Predicted",
          "Transplant",
          "rejection",
          "7",
          "days"
      ]
  },
  {
      "name": "Renal Graft Failure at 5-Years, Predicted at Time of Transplant",
      "id": "calculator_104",
      "description": "Estimate the risk of kidney transplant graft failure at 5 years",
      "categories": [
          "Nephrology",
          "Transplant"
      ],
      "tags": [
          "nephrology",
          "Risk",
          "graft",
          "failure",
          "renal",
          "5",
          "Years",
          "Predicted",
          "Transplant",
          "rejection",
          "time"
      ]
  },
  {
      "name": "Acute GVHD Grading",
      "id": "calculator_105",
      "description": "Determine severity in acute graft versus host disease.",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "graft",
          "hematology",
          "heme",
          "oncology",
          "Disease",
          "acute",
          "GVHD",
          "Grading",
          "host",
          "versus",
          "glucksberg",
          "ibmtr"
      ]
  },
  {
      "name": "Bleeding Risk in Atrial Fibrillation: HAS-BLED Score",
      "id": "calculator_106",
      "description": "Understand the risk of bleeding from anticoagulation in atrial fibrillation",
      "categories": [
          "Cardiology",
          "Geriatrics"
      ],
      "tags": [
          "cardiology",
          "Risk",
          "Score",
          "stroke",
          "liver",
          "Bleeding",
          "atrial",
          "fibrillation",
          "Afib",
          "AF",
          "CHA2DS2",
          "VASc",
          "CHA2DS2VASc",
          "renal",
          "Function",
          "OAC",
          "HAS",
          "BLED",
          "HASBLED",
          "Hypertension",
          "Abnormal",
          "History",
          "Bleeding Predisposition",
          "Labile INRs",
          "Elderly",
          "Drugs",
          "Alcohol",
          "Usage"
      ]
  },
  {
      "name": "Hodgkin's Disease | Prognosis",
      "id": "calculator_107",
      "description": "Estimate prognosis in Hodgkin's disease.",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "Score",
          "prognosis",
          "hematology",
          "heme",
          "oncology",
          "Disease",
          "Prognostic",
          "International",
          "Hodgkins",
          "hassenclever",
          "IPS"
      ]
  },
  {
      "name": "Hematopoietic cell transplantation - specific comorbidity index (HCT-CI)",
      "id": "calculator_108",
      "description": null,
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "index",
          "hematology",
          "heme",
          "oncology",
          "cell",
          "Hematopoietic",
          "transplantation",
          "specific",
          "comorbidity",
          "HCT",
          "CI",
          "allogeneic",
          "stem cell",
          "sorror",
          "hctci"
      ]
  },
  {
      "name": "MDS Revised - International Prognostic Scoring System (IPSS-R)",
      "id": "calculator_109",
      "description": "Assess mortality and progression to acute myeloid leukemia in myelodysplastic syndrome",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "hematology",
          "heme",
          "oncology",
          "Prognostic",
          "Scoring",
          "International",
          "MDS",
          "Intnl",
          "IPSS",
          "IPSSR",
          "myelodysplastic",
          "syndrome",
          "system",
          "WPSS"
      ]
  },
  {
      "name": "Hemodynamics (Echo)",
      "id": "calculator_110",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "Hemodynamics"
      ]
  },
  {
      "name": "Henderson-Hasselbalch",
      "id": "calculator_112",
      "description": null,
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "acidosis",
          "Henderson",
          "Hasselbalch",
          "acid",
          "base",
          "alkalosis",
          "pH"
      ]
  },
  {
      "name": "HIT 4T's score",
      "id": "calculator_113",
      "description": "Diagnose heparin-induced thrombocytopenia.",
      "categories": [
          "Hematology",
          "Cardiac Surgery"
      ],
      "tags": [
          "emergency",
          "er",
          "Score",
          "hematology",
          "heme",
          "oncology",
          "HIT",
          "4Ts",
          "heparin",
          "induced",
          "thrombocytopenia",
          "platelet"
      ]
  },
  {
      "name": "Hodgkin's Marrow Involvement",
      "id": "calculator_114",
      "description": "Estimate likelihood of bone marrow involvement in Hodgkin's lymphoma.",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "hematology",
          "heme",
          "oncology",
          "Hodgkins",
          "Marrow",
          "Involvement",
          "bone marrow"
      ]
  },
  {
      "name": "SAH Hunt & Hess Scale",
      "id": "calculator_116",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "neurology",
          "hemorrhage",
          "Scale",
          "SAH",
          "subarachnoid",
          "vasospasm",
          "hunt",
          "hess"
      ]
  },
  {
      "name": "ICH FUNC Score",
      "id": "calculator_117",
      "description": "Predict likelihood of functional independence after intracranial hemorrhage",
      "categories": [
          "Neurology / Neurosurgery",
          "Physical Medicine and Rehabilitation"
      ],
      "tags": [
          "Score",
          "neurology",
          "hemorrhage",
          "ICH",
          "FUNC",
          "intracranial",
          "functional",
          "independence",
          "intracerebral"
      ]
  },
  {
      "name": "ICH Score",
      "id": "calculator_118",
      "description": "Estimate mortality after intracerebral hemorrhage",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "Score",
          "stroke",
          "neurology",
          "hemorrhage",
          "ICH",
          "intracranial",
          "intracerebral"
      ]
  },
  {
      "name": "ICH Volume",
      "id": "calculator_119",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "neurology",
          "hemorrhage",
          "ICH",
          "intracranial",
          "intracerebral",
          "Volume"
      ]
  },
  {
      "name": "Metabolic Syndrome (IDF)",
      "id": "calculator_120",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "diabetes",
          "International",
          "ATP",
          "III",
          "syndrome",
          "Metabolic",
          "IDF",
          "federation",
          "atpiii"
      ]
  },
  {
      "name": "In-flight PaO₂ (based on ABG)",
      "id": "calculator_121",
      "description": null,
      "categories": [
          "Respirology"
      ],
      "tags": [
          "respirology",
          "PaO2",
          "In",
          "flight",
          "ABG",
          "O2"
      ]
  },
  {
      "name": "In-flight PaO₂ (ABG & PFT)",
      "id": "calculator_122",
      "description": null,
      "categories": [
          "Respirology"
      ],
      "tags": [
          "respirology",
          "PaO2",
          "In",
          "flight",
          "ABG",
          "O2",
          "PFT"
      ]
  },
  {
      "name": "MDS International Prognostic Scoring System (IPSS)",
      "id": "calculator_123",
      "description": "Determine prognosis in myelodysplastic sydnrome",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "hematology",
          "heme",
          "oncology",
          "Prognostic",
          "Scoring",
          "International",
          "MDS",
          "Intnl",
          "IPSS",
          "myelodysplastic",
          "syndrome",
          "system",
          "WPSS"
      ]
  },
  {
      "name": "Multiple Myeloma Prognosis (ISS)",
      "id": "calculator_124",
      "description": null,
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "prognosis",
          "hematology",
          "heme",
          "oncology",
          "International",
          "staging",
          "system",
          "Multiple",
          "Myeloma",
          "ISS"
      ]
  },
  {
      "name": "Kidney Failure Risk Equation (8 Variable)",
      "id": "calculator_125",
      "description": "Estimate risk of progression to end-stage renal disease in CKD patients using 8 variables.",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "ckd",
          "kidney",
          "Risk",
          "dialysis",
          "Chronic",
          "Disease",
          "failure",
          "Equation",
          "2011",
          "RRT",
          "Tangri",
          "pru",
          "kfre"
      ]
  },
  {
      "name": "Killip Class",
      "id": "calculator_126",
      "description": "Estimate mortality in myocardial infarction",
      "categories": [
          "Cardiology",
          "Emergency",
          "Critical Care"
      ],
      "tags": [
          "cardiology",
          "emergency",
          "er",
          "MI",
          "ACS",
          "Class",
          "CHF",
          "Killip",
          "shock",
          "myocardial infarction"
      ]
  },
  {
      "name": "Kt/V from PRU",
      "id": "calculator_127",
      "description": "Quantify hemodialysis adequacy",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "dialysis",
          "from",
          "urea",
          "pru",
          "Kt",
          "V",
          "ktv",
          "hemodialysis",
          "URR",
          "reduction",
          "ration",
          "adequacy"
      ]
  },
  {
      "name": "Kt/V Daugirdas",
      "id": "calculator_128",
      "description": "Quantify hemodialysis adequancy",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "dialysis",
          "urea",
          "Kt",
          "V",
          "ktv",
          "hemodialysis",
          "URR",
          "reduction",
          "ration",
          "adequacy",
          "Daugirdas"
      ]
  },
  {
      "name": "Left Atrial Systolic Pressure",
      "id": "calculator_132",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "atrial",
          "Pressure",
          "Left",
          "Systolic"
      ]
  },
  {
      "name": "LV/RV Contractility (dp/dt)",
      "id": "calculator_133",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "LV",
          "RV",
          "Contractility",
          "dp",
          "dt"
      ]
  },
  {
      "name": "MASCC Febrile Neutropenia Risk",
      "id": "calculator_134",
      "description": "Assess risk in febrile neutropenia and appropriateness for outpatient management",
      "categories": [
          "Infectious Disease",
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "Risk",
          "hematology",
          "heme",
          "oncology",
          "MASCC",
          "Febrile",
          "Neutropenia"
      ]
  },
  {
      "name": "6-Month Mortality on HD",
      "id": "calculator_135",
      "description": "Estimate 6 month mortality on dialysis using the Cohen model",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "dialysis",
          "mortality",
          "Prognostic",
          "Model",
          "hemodialysis",
          "6",
          "month",
          "integrated",
          "survival",
          "hd"
      ]
  },
  {
      "name": "Home HD Candidacy (MATCH-D)",
      "id": "calculator_136",
      "description": "Assess candidacy for home hemodialysis",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "dialysis",
          "d",
          "hemodialysis",
          "hd",
          "Home",
          "hhd",
          "hemo",
          "Candidacy",
          "MATCH",
          "matchd",
          "NHD",
          "nocturnal",
          "quotidian",
          "intensive"
      ]
  },
  {
      "name": "PD Candidacy (MATCH-D)",
      "id": "calculator_137",
      "description": "Assess candidacy for peritoneal dialysis",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "dialysis",
          "d",
          "hd",
          "Home",
          "Candidacy",
          "MATCH",
          "matchd",
          "PD",
          "Peritoneal",
          "central",
          "CAPD",
          "CCPD",
          "APD"
      ]
  },
  {
      "name": "Mayo Quadratic eGFR",
      "id": "calculator_138",
      "description": null,
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "ckd",
          "eGFR",
          "EPI",
          "GFR",
          "CrCl",
          "Mayo",
          "Quadratic",
          "MDRD"
      ]
  },
  {
      "name": "PCI complication - Mayo",
      "id": "calculator_139",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "PCI",
          "CAD",
          "percutaneous",
          "coronary",
          "intervention",
          "angiogram",
          "stent",
          "Mayo",
          "complication",
          "singh"
      ]
  },
  {
      "name": "MDRD eGFR",
      "id": "calculator_140",
      "description": "Calculate eGFR using the MDRD formula",
      "categories": [
          "Emergency",
          "Nephrology"
      ],
      "tags": [
          "emergency",
          "er",
          "nephrology",
          "ckd",
          "eGFR",
          "EPI",
          "GFR",
          "CrCl",
          "MDRD"
      ]
  },
  {
      "name": "MDRD eGFR (6 Variable)",
      "id": "calculator_141",
      "description": null,
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "ckd",
          "eGFR",
          "EPI",
          "GFR",
          "CrCl",
          "6",
          "MDRD",
          "six",
          "Variable"
      ]
  },
  {
      "name": "MDS Anemia - EPO/GCSF Response",
      "id": "calculator_142",
      "description": "Identify those with MDS likely to respond to stem-cell factors.",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "hematology",
          "heme",
          "oncology",
          "MDS",
          "myelodysplastic",
          "syndrome",
          "Anemia",
          "EPO",
          "GCSF",
          "Response"
      ]
  },
  {
      "name": "MDS WHO Classification-based Prognostic Scoring System (WPSS)",
      "id": "calculator_143",
      "description": "Estimate survival and risk of transformation to AML in myelodysplastic syndrome.",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "hematology",
          "heme",
          "oncology",
          "Prognostic",
          "Scoring",
          "Classification",
          "MDS",
          "IPSS",
          "myelodysplastic",
          "syndrome",
          "system",
          "WPSS",
          "Anemia",
          "WHO",
          "transfusion",
          "karyotype",
          "RARS",
          "refractory",
          "blasts",
          "Del5q",
          "5q"
      ]
  },
  {
      "name": "Prognosis after TIPSS using MELD Score",
      "id": "calculator_144",
      "description": null,
      "categories": [
          "Emergency",
          "Infectious Disease",
          "Gastroenterology"
      ],
      "tags": [
          "emergency",
          "er",
          "Score",
          "gi",
          "gastroenterology",
          "liver",
          "cirrhosis",
          "MELD",
          "Child",
          "Pugh",
          "PELD"
      ]
  },
  {
      "name": "Prognosis in Alcoholic Hepatitis",
      "id": "calculator_145",
      "description": "Estimates prognosis in alcoholic hepatitis using the MELD score",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "Score",
          "gi",
          "gastroenterology",
          "Hepatitis",
          "alcoholic",
          "MELD",
          "Child",
          "Pugh",
          "PELD"
      ]
  },
  {
      "name": "Hamilton Depression Rating Scale (HAM-D or HDRS)",
      "id": "calculator_146",
      "description": "Determine severity of depression",
      "categories": [
          "Mental Health",
          "Geriatrics"
      ],
      "tags": [
          "emergency",
          "er",
          "Scale",
          "depression",
          "hamilton",
          "rating",
          "mental",
          "health"
      ]
  },
  {
      "name": "SNAP-IV 26 - Teacher & Parent Rating Scale",
      "id": "calculator_147",
      "description": "Assess children for attention deficit hyperactivity disorder (ADHD)",
      "categories": [
          "Pediatrics",
          "Mental Health"
      ],
      "tags": [
          "pediatrics",
          "Scale",
          "rating",
          "mental",
          "health",
          "add",
          "adhd",
          "odd",
          "hyperactivity",
          "inattention",
          "impulsivity",
          "snap",
          "teacher",
          "parent",
          "peds"
      ]
  },
  {
      "name": "MGUS Prognosis",
      "id": "calculator_148",
      "description": "Determine risk of malignant progression to myleoma or lymphoproliferative disorder.",
      "categories": [
          "Hematology",
          "Oncology",
          "Geriatrics"
      ],
      "tags": [
          "prognosis",
          "hematology",
          "heme",
          "oncology",
          "Myeloma",
          "MGUS",
          "monoclonal",
          "gammopathy",
          "Waldenstrom"
      ]
  },
  {
      "name": "MIPI - Mantle Cell Lymphoma Prognosis",
      "id": "calculator_149",
      "description": "Estimate prognosis in mantle cell lymphoma.",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "prognosis",
          "index",
          "hematology",
          "heme",
          "oncology",
          "Prognostic",
          "International",
          "cell",
          "lymphoma",
          "MIPI",
          "Mantle",
          "ecog",
          "Ki67",
          "MIPIb"
      ]
  },
  {
      "name": "Modified Bernoulli Equation",
      "id": "calculator_150",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "Equation",
          "Modified",
          "Bernoulli"
      ]
  },
  {
      "name": "Modified Fisher Scale",
      "id": "calculator_151",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "neurology",
          "hemorrhage",
          "Scale",
          "SAH",
          "Fisher",
          "Modified",
          "subarachonoid",
          "intraventricular"
      ]
  },
  {
      "name": "Modified Rankin Scale (mRS)",
      "id": "calculator_152",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "stroke",
          "cva",
          "neurology",
          "Scale",
          "Modified",
          "Rankin",
          "mRS"
      ]
  },
  {
      "name": "Modified Strep Score",
      "id": "calculator_153",
      "description": null,
      "categories": [
          "Pediatrics",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Score",
          "ent",
          "ear",
          "nose",
          "throat",
          "Modified",
          "gas",
          "streptococcal",
          "pharyngitis",
          "Strep",
          "streptococcus"
      ]
  },
  {
      "name": "MR: Quantification (PISA)",
      "id": "calculator_154",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "Quantification",
          "regurgitation",
          "echo",
          "echocardiogram",
          "PISA",
          "MR",
          "mitral"
      ]
  },
  {
      "name": "MR: Quantification (Volumetric)",
      "id": "calculator_155",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "Quantification",
          "Volumetric",
          "regurgitation",
          "echo",
          "echocardiogram",
          "MR",
          "mitral"
      ]
  },
  {
      "name": "MS: Wilkins' Echo Score",
      "id": "calculator_156",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "Score",
          "echo",
          "echocardiogram",
          "stenosis",
          "mitral",
          "MS",
          "Wilkins"
      ]
  },
  {
      "name": "MS: Mitral Valve Area (Cont)",
      "id": "calculator_157",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "Valve",
          "Area",
          "Cont",
          "stenosis",
          "mitral",
          "MS"
      ]
  },
  {
      "name": "MS: Mitral Valve Area (Gorlin)",
      "id": "calculator_158",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "Valve",
          "Area",
          "stenosis",
          "Gorlin",
          "mitral",
          "MS"
      ]
  },
  {
      "name": "MS: Mitral Valve Area (PHT)",
      "id": "calculator_159",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "Valve",
          "Area",
          "stenosis",
          "mitral",
          "MS",
          "PHT"
      ]
  },
  {
      "name": "MS: Mitral Valve Area (PISA)",
      "id": "calculator_160",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "PISA",
          "Valve",
          "Area",
          "stenosis",
          "mitral",
          "MS"
      ]
  },
  {
      "name": "MS: Mitral Valve Area (Hakki)",
      "id": "calculator_161",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "Valve",
          "Area",
          "stenosis",
          "Hakki",
          "mitral",
          "MS"
      ]
  },
  {
      "name": "Myocardial Performance Index (CO and ET)",
      "id": "calculator_162",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "myocardial",
          "index",
          "HEART",
          "CHF",
          "failure",
          "Ejection",
          "time",
          "Performance",
          "CO",
          "ET",
          "closure",
          "opening",
          "tei",
          "doppler"
      ]
  },
  {
      "name": "Myocardial Performance Index (IVRT and IVCT)",
      "id": "calculator_163",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "myocardial",
          "index",
          "time",
          "Performance",
          "IVRT",
          "IVCT",
          "isovolemic",
          "contraction",
          "relaxation"
      ]
  },
  {
      "name": "Nasal Cannula FiO₂ Estimation",
      "id": "calculator_164",
      "description": null,
      "categories": [
          "Respirology"
      ],
      "tags": [
          "respirology",
          "FiO2",
          "nasal",
          "O2",
          "Cannula",
          "Estimation"
      ]
  },
  {
      "name": "NEXUS C-Spine Criteria",
      "id": "calculator_165",
      "description": "Determine whether cervical spine imaging can be safely avoided",
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery",
          "Orthopedics",
          "Surgery",
          "Medical Imaging"
      ],
      "tags": [
          "emergency",
          "er",
          "cervical",
          "fracture",
          "trauma",
          "orthopedics",
          "C",
          "Spine",
          "NEXUS",
          "Criteria",
          "hoffman"
      ]
  },
  {
      "name": "TIMI Risk Score (NSTEMI)",
      "id": "calculator_168",
      "description": "Guide therapeutic decisions in non-ST elevation MI. ",
      "categories": [
          "Cardiology",
          "Emergency",
          "Critical Care"
      ],
      "tags": [
          "cardiology",
          "emergency",
          "er",
          "Risk",
          "Score",
          "MI",
          "ACS",
          "NSTEMI",
          "TIMI"
      ]
  },
  {
      "name": "Carboplatin AUC Dosing (Calvert)",
      "id": "calculator_169",
      "description": null,
      "categories": [
          "Oncology"
      ],
      "tags": [
          "Area",
          "dosing",
          "oncology",
          "GFR",
          "Carboplatin",
          "AUC",
          "Calvert",
          "under",
          "curve",
          "chemotherapy"
      ]
  },
  {
      "name": "Prognosis in Renal Cell Carcinoma (UISS)",
      "id": "calculator_170",
      "description": "Estimate survival in renal cell carcinoma",
      "categories": [
          "Urology",
          "Oncology"
      ],
      "tags": [
          "prognosis",
          "oncology",
          "renal",
          "cell",
          "Carcinoma",
          "TNM",
          "UISS",
          "RCC",
          "Nephrectomy",
          "Zisman"
      ]
  },
  {
      "name": "Osmolal Gap",
      "id": "calculator_171",
      "description": "Detect unmeasured osmoles, such as toxic alcohols",
      "categories": [
          "Emergency",
          "Nephrology"
      ],
      "tags": [
          "emergency",
          "er",
          "nephrology",
          "Gap",
          "Osmolal",
          "Osmolality",
          "Osm",
          "ethylene",
          "glycol",
          "methanol",
          "DKA",
          "ketones",
          "ketone",
          "ethanol",
          "EtOH",
          "lactate",
          "lactic acidosis"
      ]
  },
  {
      "name": "Ottawa Ankle Rules",
      "id": "calculator_172",
      "description": "Does this ankle injury require an x-ray?",
      "categories": [
          "Emergency",
          "Orthopedics",
          "Medical Imaging"
      ],
      "tags": [
          "emergency",
          "er",
          "fracture",
          "xray",
          "x",
          "ray",
          "orthopedics",
          "Ottawa",
          "Ankle",
          "Rules",
          "weight",
          "bear",
          "lateral",
          "malleolus",
          "medical",
          "5th",
          "metatarsal",
          "navicular"
      ]
  },
  {
      "name": "Ottawa Knee Rules",
      "id": "calculator_173",
      "description": "Does this knee injury require an x-ray?",
      "categories": [
          "Emergency",
          "Orthopedics",
          "Surgery",
          "Medical Imaging"
      ],
      "tags": [
          "emergency",
          "er",
          "fracture",
          "xray",
          "x",
          "ray",
          "orthopedics",
          "Ottawa",
          "Rules",
          "Knee",
          "patella",
          "patellar",
          "fibula",
          "weight bear",
          "flex"
      ]
  },
  {
      "name": "PaO₂:FiO₂ Ratio",
      "id": "calculator_174",
      "description": null,
      "categories": [
          "Respirology"
      ],
      "tags": [
          "respirology",
          "Pressure",
          "Fraction",
          "Fractional",
          "syndrome",
          "Ratio",
          "ARDS",
          "adult",
          "respiratory",
          "distress",
          "Pa02",
          "Fi02",
          "partial",
          "oxygen",
          "inspired",
          "arterial"
      ]
  },
  {
      "name": "Parkland Formula",
      "id": "calculator_175",
      "description": "Manage IV fluids required in burns",
      "categories": [
          "Emergency",
          "Surgery",
          "Critical Care"
      ],
      "tags": [
          "emergency",
          "er",
          "Burns",
          "Parkland",
          "Formula",
          "burn",
          "fluid",
          "resuscitation",
          "degree"
      ]
  },
  {
      "name": "PCI mortality - Michigan",
      "id": "calculator_176",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "mortality",
          "PCI",
          "CAD",
          "percutaneous",
          "coronary",
          "intervention",
          "angiogram",
          "stent",
          "Michigan"
      ]
  },
  {
      "name": "PCWP (Echo)",
      "id": "calculator_177",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "Pulmonary",
          "echo",
          "echocardiogram",
          "Pressure",
          "mitral",
          "PCWP",
          "capillary",
          "wedge",
          "inflow",
          "annulus",
          "velocity"
      ]
  },
  {
      "name": "PE Clinical Probability",
      "id": "calculator_178",
      "description": "Determine pretest probability of PE to guide workup",
      "categories": [
          "Emergency",
          "Urology",
          "Respirology",
          "Hematology",
          "Orthopedics",
          "Critical Care",
          "Medical Imaging"
      ],
      "tags": [
          "emergency",
          "er",
          "Pulmonary",
          "respirology",
          "hematology",
          "heme",
          "oncology",
          "orthopedics",
          "DVT",
          "Clinical",
          "Probability",
          "PE",
          "embolism",
          "wells",
          "Well"
      ]
  },
  {
      "name": "Peak Expiratory Flow Prediction",
      "id": "calculator_179",
      "description": null,
      "categories": [
          "Emergency",
          "Respirology"
      ],
      "tags": [
          "emergency",
          "er",
          "respirology",
          "Peak",
          "Expiratory",
          "Flow",
          "Prediction",
          "PEF",
          "asthma",
          "exacerbation"
      ]
  },
  {
      "name": "Pediatric Endotracheal Tube Size",
      "id": "calculator_180",
      "description": null,
      "categories": [
          "Emergency",
          "Pediatrics",
          "Anesthesiology"
      ],
      "tags": [
          "emergency",
          "er",
          "size",
          "pediatric",
          "ET",
          "Endotracheal",
          "Tube",
          "ETT",
          "intubation"
      ]
  },
  {
      "name": "Pediatric Glasgow Coma Scale",
      "id": "calculator_181",
      "description": null,
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery",
          "Pediatrics"
      ],
      "tags": [
          "emergency",
          "er",
          "pediatric",
          "GCS",
          "Scale",
          "coma",
          "Glasgow"
      ]
  },
  {
      "name": "Pediatric Strep Score",
      "id": "calculator_182",
      "description": null,
      "categories": [
          "Emergency",
          "Infectious Disease",
          "Pediatrics"
      ],
      "tags": [
          "emergency",
          "er",
          "Score",
          "pediatric",
          "streptococcal",
          "pharyngitis",
          "Strep"
      ]
  },
  {
      "name": "PELD Score - Age Younger Than 12 years",
      "id": "calculator_183",
      "description": "PELD (Pediatric End-Stage Liver Disease) is used for liver allocation in the OPTN match system",
      "categories": [
          "Emergency",
          "Pediatrics",
          "Gastroenterology",
          "Transplant"
      ],
      "tags": [
          "emergency",
          "er",
          "Score",
          "gi",
          "gastroenterology",
          "pediatric",
          "liver",
          "Disease",
          "MELD",
          "Stage",
          "PELD",
          "end"
      ]
  },
  {
      "name": "Disability Rating Scale (DRS)",
      "id": "calculator_184",
      "description": null,
      "categories": [
          "Physical Medicine and Rehabilitation"
      ],
      "tags": [
          "Scale",
          "coma",
          "functional",
          "rating",
          "Disability",
          "DRS",
          "physical",
          "rehabilitation",
          "Traumatic",
          "Brain",
          "Injury",
          "Assessment",
          "Outcome",
          "Measurement",
          "TBI",
          "Wright"
      ]
  },
  {
      "name": "Modified Ashworth Scale (MAS)",
      "id": "calculator_185",
      "description": null,
      "categories": [
          "Physical Medicine and Rehabilitation"
      ],
      "tags": [
          "Scale",
          "syndrome",
          "Modified",
          "physical",
          "rehabilitation",
          "Ashworth",
          "MAS",
          "Spasticity",
          "Upper",
          "Motor",
          "Neuron",
          "Tone"
      ]
  },
  {
      "name": "National Pressure Ulcer Advisory Panel Staging System (NPUAP)",
      "id": "calculator_186",
      "description": null,
      "categories": [
          "Physical Medicine and Rehabilitation"
      ],
      "tags": [
          "Pressure",
          "staging",
          "system",
          "physical",
          "rehabilitation",
          "Injury",
          "National",
          "Ulcer",
          "Advisory",
          "Panel",
          "NPUAP",
          "Ulcers",
          "Spinal",
          "Cord",
          "SCI"
      ]
  },
  {
      "name": "DIPSS Prognosis in Myelofibrosis",
      "id": "calculator_187",
      "description": "Estimate prognosis in myelofibrosis.",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "hematology",
          "heme",
          "oncology",
          "Scoring",
          "system",
          "Myelofibrosis",
          "cervantes"
      ]
  },
  {
      "name": "Pneumonia risk (CURB-65)",
      "id": "calculator_188",
      "description": "Estimate prognosis and determine disposition in community-acquired pneumonia. Not yet validated in COVID-19",
      "categories": [
          "Emergency",
          "Respirology",
          "Infectious Disease",
          "Critical Care",
          "Geriatrics"
      ],
      "tags": [
          "emergency",
          "er",
          "Risk",
          "respirology",
          "Severity",
          "index",
          "Pneumonia",
          "CURB",
          "65",
          "PORT",
          "CAP",
          "lim",
          "fine"
      ]
  },
  {
      "name": "Pulmonary Resistance",
      "id": "calculator_189",
      "description": null,
      "categories": [
          "Cardiology",
          "Critical Care"
      ],
      "tags": [
          "cardiology",
          "Pulmonary",
          "PCWP",
          "Flow",
          "Resistance",
          "PAP",
          "TPR",
          "PVR"
      ]
  },
  {
      "name": "Ranson's Criteria",
      "id": "calculator_190",
      "description": "Estimate mortality in patients with pancreatitis.\r\n",
      "categories": [
          "Emergency",
          "Gastroenterology",
          "Critical Care"
      ],
      "tags": [
          "emergency",
          "er",
          "prognosis",
          "gi",
          "gastroenterology",
          "Criteria",
          "pancreatitis",
          "Ransons"
      ]
  },
  {
      "name": "Rate Pressure Product",
      "id": "calculator_191",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "rate",
          "Pressure",
          "exercise",
          "Product"
      ]
  },
  {
      "name": "Reynolds CAD Risk",
      "id": "calculator_192",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "Risk",
          "CAD",
          "coronary",
          "Disease",
          "artery",
          "lipid",
          "Framingham",
          "Reynolds"
      ]
  },
  {
      "name": "Alcohol Addiction Risk of Relapse",
      "id": "calculator_193",
      "description": null,
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "Risk",
          "gi",
          "gastroenterology",
          "Hepatitis",
          "liver",
          "Relapse",
          "abuse",
          "alcoholism"
      ]
  },
  {
      "name": "Alcohol Relapse Risk after Liver Transplant",
      "id": "calculator_194",
      "description": null,
      "categories": [
          "Gastroenterology",
          "Transplant"
      ],
      "tags": [
          "Risk",
          "gi",
          "gastroenterology",
          "liver",
          "cirrhosis",
          "Transplant",
          "Relapse",
          "alcoholism",
          "alcohol abuse"
      ]
  },
  {
      "name": "Revised Cardiac Risk Index (Lee Criteria)",
      "id": "calculator_195",
      "description": "Rapid pre-op assessment using the Revised Cardiac Risk Index",
      "categories": [
          "Cardiology",
          "Anesthesiology"
      ],
      "tags": [
          "cardiology",
          "Risk",
          "index",
          "Cardiac",
          "Criteria",
          "revised",
          "Lee",
          "detsky",
          "eagle",
          "gupta",
          "VSG",
          "CRI"
      ]
  },
  {
      "name": "Adult Onset Still's Disease, Diagnostic Criteria",
      "id": "calculator_196",
      "description": "Diagnose Adult Onset Still's Disease.",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "Disease",
          "Criteria",
          "adult",
          "Onset",
          "stills",
          "Diagnostic",
          "rheumatology"
      ]
  },
  {
      "name": "Simplified Disease Activity Index for RA (SDAI)",
      "id": "calculator_197",
      "description": "Assess disease activity in rheumatoid arthritis.",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "index",
          "Disease",
          "Simplified",
          "rheumatology",
          "determine",
          "Activity",
          "RA",
          "SDAI",
          "rheumatoid",
          "arhritis",
          "DMARD",
          "SJC",
          "TJC",
          "PGA",
          "EGA",
          "CRP",
          "remission"
      ]
  },
  {
      "name": "Membranous Prognosis",
      "id": "calculator_198",
      "description": "Estimate risk of progressive renal dysfunction in membranous nephropathy",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "prognosis",
          "Nephropathy",
          "Membranous",
          "proteinuria",
          "cattran",
          "nephrotic"
      ]
  },
  {
      "name": "Rockall Score",
      "id": "calculator_199",
      "description": "Estimate risk of mortality after endoscopy for GI bleed.",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "Score",
          "gi",
          "gastroenterology",
          "Bleed",
          "endoscopy",
          "Rockall"
      ]
  },
  {
      "name": "RV Systolic Pressure (TR Jet)",
      "id": "calculator_200",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "regurgitation",
          "echo",
          "echocardiogram",
          "Pressure",
          "Systolic",
          "RV",
          "TR",
          "Jet",
          "right",
          "ventricle",
          "tricuspid",
          "RVSP"
      ]
  },
  {
      "name": "Modified SAD PERSONS Scale",
      "id": "calculator_201",
      "description": "Assess depression with the modified SAD PERSONS Scale",
      "categories": [
          "Emergency",
          "Mental Health"
      ],
      "tags": [
          "emergency",
          "er",
          "Scale",
          "depression",
          "Modified",
          "SAD",
          "PERSONS"
      ]
  },
  {
      "name": "Seattle Heart Failure Model",
      "id": "calculator_203",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "HEART",
          "CHF",
          "failure",
          "Model",
          "Seattle"
      ]
  },
  {
      "name": "Shunt Fraction (Echo)",
      "id": "calculator_204",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "echo",
          "echocardiogram",
          "Fraction",
          "Shunt",
          "LVOT",
          "RVOT"
      ]
  },
  {
      "name": "Shunt Fraction (Invasive)",
      "id": "calculator_205",
      "description": null,
      "categories": [
          "Cardiology",
          "Critical Care"
      ],
      "tags": [
          "cardiology",
          "Fraction",
          "Shunt",
          "Invasive"
      ]
  },
  {
      "name": "Smoldering Multiple Myeloma Prognosis",
      "id": "calculator_206",
      "description": "Determine risk of progression to symptomatic multiple myeloma.",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "prognosis",
          "hematology",
          "heme",
          "oncology",
          "Multiple",
          "Myeloma",
          "Smoldering",
          "MM",
          "plasmacytosis",
          "mprotein",
          "SMM"
      ]
  },
  {
      "name": "Spetzler-Martin Score",
      "id": "calculator_207",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "Score",
          "neurology",
          "AVM",
          "malformation",
          "Spetzler",
          "Martin",
          "ateriovenous"
      ]
  },
  {
      "name": "TIMI Risk Score (STEMI)",
      "id": "calculator_208",
      "description": null,
      "categories": [
          "Cardiology",
          "Emergency",
          "Critical Care"
      ],
      "tags": [
          "cardiology",
          "emergency",
          "er",
          "Risk",
          "Score",
          "MI",
          "ACS",
          "TIMI",
          "STEMI"
      ]
  },
  {
      "name": "Stevenson HF Class",
      "id": "calculator_209",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "mortality",
          "Class",
          "CHF",
          "hf",
          "Stevenson"
      ]
  },
  {
      "name": "Systemic Vascular Resistance",
      "id": "calculator_210",
      "description": null,
      "categories": [
          "Cardiology",
          "Critical Care"
      ],
      "tags": [
          "cardiology",
          "vascular",
          "Resistance",
          "Systemic",
          "SVR"
      ]
  },
  {
      "name": "t-PA Dosing in Acute Stroke",
      "id": "calculator_211",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "stroke",
          "cva",
          "neurology",
          "dosing",
          "acute",
          "tPA",
          "t",
          "pa"
      ]
  },
  {
      "name": "TICI Score",
      "id": "calculator_212",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "Score",
          "neurology",
          "infarction",
          "Cerebral",
          "TICI",
          "Thrombolysis"
      ]
  },
  {
      "name": "Transtubular K Gradient",
      "id": "calculator_213",
      "description": "Workup hypokalemia and hyperkalemia",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "Gradient",
          "Transtubular",
          "K",
          "TTKG",
          "potassium",
          "hyperkalemia",
          "hypokalemia"
      ]
  },
  {
      "name": "Percent Reduction of Urea",
      "id": "calculator_214",
      "description": null,
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "urea",
          "pru",
          "Kt",
          "V",
          "ktv",
          "reduction",
          "Percent"
      ]
  },
  {
      "name": "VALIANT Heart Failure Risk Score",
      "id": "calculator_215",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "cardiology",
          "Risk",
          "Score",
          "HEART",
          "CHF",
          "failure",
          "hf",
          "VALIANT",
          "hospitalization"
      ]
  },
  {
      "name": "Asymptomatic ICA (Internal Carotid Artery) Stenosis Surgical Risk Stratification",
      "id": "calculator_216",
      "description": null,
      "categories": [
          "Cardiology",
          "Neurology / Neurosurgery",
          "Vascular Surgery",
          "Anesthesiology"
      ],
      "tags": [
          "cardiology",
          "Risk",
          "stroke",
          "neurology",
          "vascular",
          "survival",
          "carotid",
          "endarterectomy",
          "stenting",
          "analysis"
      ]
  },
  {
      "name": "Warfarin Bleeding Risk - Elderly",
      "id": "calculator_222",
      "description": "Estimate 90 day risk of bleeding in patients on warfarin who are &gt;65 years",
      "categories": [
          "Cardiology",
          "Geriatrics"
      ],
      "tags": [
          "cardiology",
          "Risk",
          "Warfarin",
          "Bleeding",
          "atrial",
          "fibrillation",
          "Afib",
          "AF",
          "Elderly"
      ]
  },
  {
      "name": "Water Deficit in Hypernatremia",
      "id": "calculator_223",
      "description": "Determine water replacement in hypernatremia",
      "categories": [
          "Emergency",
          "Nephrology",
          "Geriatrics"
      ],
      "tags": [
          "emergency",
          "er",
          "nephrology",
          "Sodium",
          "na",
          "Water",
          "Deficit",
          "hypernatremia"
      ]
  },
  {
      "name": "Westley Croup Score",
      "id": "calculator_224",
      "description": "Assess croup severity",
      "categories": [
          "Emergency",
          "Infectious Disease",
          "Pediatrics"
      ],
      "tags": [
          "emergency",
          "er",
          "Score",
          "Croup",
          "cough",
          "pediatrics",
          "Westley"
      ]
  },
  {
      "name": "WFNS SAH Scale",
      "id": "calculator_225",
      "description": null,
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "neurology",
          "hemorrhage",
          "GCS",
          "Scale",
          "SAH",
          "subarachnoid",
          "WFNS",
          "world federation of neurological surgeons"
      ]
  },
  {
      "name": "Before Induction of Anaesthesia",
      "id": "calculator_226",
      "description": "Reduce peri-operative death with the WHO Surgical Safety Checklist - 1st step.",
      "categories": [
          "Urology",
          "Vascular Surgery",
          "Surgery"
      ],
      "tags": [
          "Surgery",
          "induction",
          "Surgical",
          "Before",
          "Anaesthesia",
          "or",
          "Safe",
          "checklist",
          "safety"
      ]
  },
  {
      "name": "Before Patient Leaves OR",
      "id": "calculator_227",
      "description": "Last step in the surgical safety checklist",
      "categories": [
          "Urology",
          "Vascular Surgery",
          "Surgery"
      ],
      "tags": [
          "Surgery",
          "Surgical",
          "Before",
          "Anaesthesia",
          "or",
          "Safe",
          "checklist",
          "safety",
          "patient",
          "leaves"
      ]
  },
  {
      "name": "Before Skin Incision",
      "id": "calculator_228",
      "description": "2nd step in the surgical safety checklist",
      "categories": [
          "Urology",
          "Vascular Surgery",
          "Surgery"
      ],
      "tags": [
          "Surgery",
          "Surgical",
          "Before",
          "Anaesthesia",
          "or",
          "Safe",
          "checklist",
          "safety",
          "skin",
          "incision"
      ]
  },
  {
      "name": "Membrane Transport Type",
      "id": "calculator_230",
      "description": null,
      "categories": ["General Calculators"],
      "tags": []
  },
  {
      "name": "Residual Kidney Function",
      "id": "calculator_231",
      "description": null,
      "categories": ["General Calculators"],
      "tags": []
  },
  {
      "name": "Residual Urea Clearance",
      "id": "calculator_232",
      "description": null,
      "categories": ["General Calculators"],
      "tags": []
  },
  {
      "name": "Volume of Distribution of Urea",
      "id": "calculator_233",
      "description": null,
      "categories": [
          "Nephrology"
      ],
      "tags": []
  },
  {
      "name": "Patient Characteristics?",
      "id": "calculator_234",
      "description": null,
      "categories": ["General Calculators"],
      "tags": []
  },
  {
      "name": "PD Prescription",
      "id": "calculator_235",
      "description": "Generate a personalized peritoneal dialysis prescription",
      "categories": ["General Calculators"],
      "tags": []
  },
  {
      "name": "FINDRISC Diabetes Risk Calculator",
      "id": "calculator_236",
      "description": "Estimate risk of developing diabetes and frequency of screening required.",
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "Risk",
          "diabetes",
          "2",
          "bmi",
          "endocrinology",
          "1",
          "glucose",
          "preventative",
          "medicine",
          "findrisc",
          "canrisk",
          "igt",
          "tolerance",
          "a1c",
          "hba1c",
          "waist",
          "fruit",
          "vegetable",
          "type",
          "dm",
          "dm2"
      ]
  },
  {
      "name": "Familial Hypercholesterolemia",
      "id": "calculator_238",
      "description": "Diagnose familial hypercholesterolemia",
      "categories": [
          "Cardiology",
          "Endocrinology"
      ],
      "tags": [
          "lipid",
          "Familial",
          "Hypercholesterolemia",
          "LDL",
          "Lipids",
          "Cholesterol",
          "Xanthoma",
          "Arcus",
          "TG",
          "TC",
          "LDLR"
      ]
  },
  {
      "name": "Due Date by LMP",
      "id": "calculator_240",
      "description": "Pregnancy due date calculator",
      "categories": [
          "Obstetrics & Gynecology",
          "Medical Imaging",
          "Anesthesiology"
      ],
      "tags": [
          "pregnancy",
          "Due",
          "Date",
          "LMP",
          "last",
          "menstrual",
          "period",
          "EDC",
          "estimated",
          "confinement",
          "EDD",
          "ultrasound",
          "wheel"
      ]
  },
  {
      "name": "Due Date by Ultrasound",
      "id": "calculator_241",
      "description": "Determine pregnancy due date using ultrasound results",
      "categories": [
          "Obstetrics & Gynecology",
          "Medical Imaging",
          "Anesthesiology"
      ],
      "tags": [
          "pregnancy",
          "Due",
          "Date",
          "LMP",
          "last",
          "menstrual",
          "period",
          "EDC",
          "estimated",
          "confinement",
          "EDD",
          "ultrasound",
          "wheel"
      ]
  },
  {
      "name": "Gestational Age",
      "id": "calculator_244",
      "description": null,
      "categories": [
          "Obstetrics & Gynecology",
          "Medical Imaging"
      ],
      "tags": [
          "pregnancy",
          "LMP",
          "Gestational",
          "Age",
          "dates"
      ]
  },
  {
      "name": "Gupta Perioperative Cardiac Risk",
      "id": "calculator_245",
      "description": "Determine peri-operative risk for a wide variety of surgeries",
      "categories": [
          "Cardiology",
          "Urology",
          "Surgery",
          "Anesthesiology",
          "Transplant"
      ],
      "tags": [
          "cardiology",
          "Risk",
          "Surgery",
          "index",
          "Cardiac",
          "Surgical",
          "revised",
          "gupta",
          "perioperative"
      ]
  },
  {
      "name": "Ideal Body Weight",
      "id": "calculator_246",
      "description": null,
      "categories": [
          "General Calculators"
      ],
      "tags": [
          "body",
          "mass",
          "index",
          "bmi",
          "weight",
          "Ideal",
          "ibw"
      ]
  },
  {
      "name": "Phenytoin Adjustment in Renal Failure",
      "id": "calculator_247",
      "description": null,
      "categories": [
          "Nephrology",
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "nephrology",
          "ckd",
          "neurology",
          "dialysis",
          "failure",
          "renal",
          "Phenytoin",
          "Adjustment",
          "ESRD",
          "albumin"
      ]
  },
  {
      "name": "Pneumonia Severity Index (PORT Score)",
      "id": "calculator_248",
      "description": "Determine need for admission in pneumonia. Not yet validated in COVID-19.",
      "categories": [
          "Respirology",
          "Infectious Disease",
          "Critical Care",
          "Geriatrics"
      ],
      "tags": [
          "respirology",
          "Severity",
          "index",
          "Pneumonia",
          "CURB",
          "65",
          "PORT",
          "lim",
          "fine"
      ]
  },
  {
      "name": "Serum Ascites to Albumin Gradient (SAAG)",
      "id": "calculator_249",
      "description": "Determine if ascites due to portal hypertension.",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "Gradient",
          "gi",
          "gastroenterology",
          "cirrhosis",
          "ascites",
          "Hypertension",
          "albumin",
          "Serum",
          "SAAG",
          "portal"
      ]
  },
  {
      "name": "Mangled Extremity Severity Score (MESS)",
      "id": "calculator_250",
      "description": "Assess limb-salvage potential in trauma to the extremity.",
      "categories": [
          "Orthopedics",
          "Surgery"
      ],
      "tags": [
          "Score",
          "Severity",
          "trauma",
          "orthopedics",
          "Extremity",
          "Mangled",
          "MESS",
          "salvage"
      ]
  },
  {
      "name": "eGFR using CKD-EPI (2021 update)",
      "id": "calculator_251",
      "description": "Calculate eGFR using CKD EPI 2021 Formula ",
      "categories": [
          "Nephrology",
          "Geriatrics",
          "Pathology & Lab Medicine"
      ],
      "tags": [
          "chronic kidney disease",
          "Serum Creatinine",
          "eGFR estimated Glomerular filtration rate"
      ]
  },
  {
      "name": "Framingham Risk Score (2008)",
      "id": "calculator_252",
      "description": null,
      "categories": [
          "Cardiology"
      ],
      "tags": []
  },
  {
      "name": "Framingham Risk Score (ATP-III)",
      "id": "calculator_253",
      "description": "Determine lipid treatment using Framingham Risk Score",
      "categories": [
          "Cardiology"
      ],
      "tags": []
  },
  {
      "name": "Postoperative Respiratory Failure Risk Calculator",
      "id": "calculator_261",
      "description": "Estimate risk of postoperative respiratory failure",
      "categories": [
          "Urology",
          "Respirology",
          "Obstetrics & Gynecology",
          "Orthopedics",
          "Otolaryngology (ENT)",
          "Surgery",
          "Critical Care",
          "Anesthesiology",
          "Transplant"
      ],
      "tags": [
          "Risk",
          "respirology",
          "Surgery",
          "pregnancy",
          "Surgical",
          "failure",
          "ent",
          "respiratory",
          "intubation",
          "gupta",
          "or",
          "Postoperative",
          "estimate",
          "Calculator",
          "otolaryngology",
          "obstetrics",
          "PRF",
          "wean",
          "mechanical",
          "ventilation",
          "reintubation"
      ]
  },
  {
      "name": "GRACE",
      "id": "calculator_262",
      "description": "The GRACE ACS risk calculator estimates risk of death following acute coronary syndrome (ACS)",
      "categories": [
          "Cardiology",
          "Emergency",
          "Critical Care"
      ],
      "tags": [
          "MI",
          "myocardial",
          "infarction",
          "ACS",
          "coronary",
          "cardiovascular",
          "acute",
          "syndrome",
          "Killip",
          "grace",
          "mace",
          "death"
      ]
  },
  {
      "name": "Calcium Correction for Hypoalbuminemia",
      "id": "calculator_267",
      "description": "Adjust serum calcium in the setting of low albumin",
      "categories": [
          "Nephrology",
          "Endocrinology",
          "Pathology & Lab Medicine"
      ],
      "tags": [
          "calcium",
          "albumin",
          "ionized",
          "hypoalbuminemia"
      ]
  },
  {
      "name": "Sequential Organ Failure Assessment (SOFA)",
      "id": "calculator_268",
      "description": "Document clinical severity in the ICU and predict mortality",
      "categories": [
          "Nephrology",
          "Infectious Disease",
          "Cardiac Surgery",
          "Critical Care",
          "Anesthesiology"
      ],
      "tags": [
          "FiO2",
          "PaO2",
          "CSICU",
          "SOFA"
      ]
  },
  {
      "name": "Alvarado Score for Acute Appendicitis",
      "id": "calculator_269",
      "description": "Diagnose appendicitis",
      "categories": [
          "Emergency",
          "Surgery"
      ],
      "tags": [
          "appy",
          "appendicitis",
          "alvarado"
      ]
  },
  {
      "name": "CIWA-Ar",
      "id": "calculator_270",
      "description": "Optimize benzodiazepine treatment of patients alcohol withdrawal",
      "categories": [
          "Emergency",
          "Mental Health",
          "Critical Care"
      ],
      "tags": [
          "Alcohol",
          "EtOH",
          "withdrawal",
          "ciwa",
          "benzo",
          "benzodiazepine"
      ]
  },
  {
      "name": "Patient Health Questionnaire-9 (PHQ-9)",
      "id": "calculator_271",
      "description": "Screening tool to assist in identifying major depressive disorder",
      "categories": [
          "Mental Health",
          "Geriatrics"
      ],
      "tags": [
          "depression",
          "mde",
          "major depression"
      ]
  },
  {
      "name": "DRAGON Score for Post-TPA Stroke Outcome",
      "id": "calculator_272",
      "description": "The DRAGON Score predicts outcome at 3 months in ischemic stroke patients receiving tPA.",
      "categories": [
          "Neurology / Neurosurgery",
          "Physical Medicine and Rehabilitation"
      ],
      "tags": [
          "stroke",
          "prognosis",
          "mRS",
          "tPA",
          "alteplase",
          "NIHSS"
      ]
  },
  {
      "name": "NIH Stroke Scale/Score (NIHSS)",
      "id": "calculator_273",
      "description": "NIH Stroke Scale provides an assessment for stroke severity.",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "stroke",
          "cva",
          "NIHSS",
          "NIH"
      ]
  },
  {
      "name": "SLICC SLE Criteria",
      "id": "calculator_274",
      "description": "The SLICC criteria are validated criteria for making the diagnosis of lupus.",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "Lupus",
          "SLE",
          "SLICC",
          "ACR"
      ]
  },
  {
      "name": "DAS28-CRP for Rheumatoid Arthritis ",
      "id": "calculator_275",
      "description": "Assess disease activity in rheumatoid arthritis.",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "RA",
          "rheumatoid",
          "CRP",
          "ESR",
          "Arthritis"
      ]
  },
  {
      "name": "DAS28-ESR for Rheumatoid Arthritis ",
      "id": "calculator_276",
      "description": "Assess disease activity in rheumatoid arthritis.",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "RA",
          "rheumatoid",
          "CRP",
          "ESR",
          "Arthritis"
      ]
  },
  {
      "name": "Geriatric Depression Scale",
      "id": "calculator_277",
      "description": "A questionnaire to screen for depression in geriatric populations",
      "categories": [
          "Mental Health",
          "Geriatrics"
      ],
      "tags": [
          "depression",
          "SAD",
          "mde",
          "geriatric",
          "depressed"
      ]
  },
  {
      "name": "Jones Criteria for Diagnosis of Rheumatic Fever",
      "id": "calculator_278",
      "description": "Diagnose acute rheumatic fever",
      "categories": [
          "Cardiology",
          "Infectious Disease",
          "Rheumatology"
      ],
      "tags": [
          "Strep",
          "Jones",
          "ARF",
          "Rheumatic",
          "Fever",
          "Carditis",
          "Sydenham",
          "Sydenham's"
      ]
  },
  {
      "name": "Clinical Disease Activity Index for RA (CDAI)",
      "id": "calculator_279",
      "description": "Assess disease activity in rheumatoid arthritis, without requiring lab work.",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "RA",
          "SDAI",
          "rheumatoid",
          "Arthritis",
          "CDAI",
          "DAS",
          "DAS28"
      ]
  },
  {
      "name": "Surgical Apgar Score",
      "id": "calculator_280",
      "description": "Assess surgical risk of complications or death at 30 days, as assessed in the post-operative period.",
      "categories": [
          "Vascular Surgery",
          "Surgery"
      ],
      "tags": [
          "APGAR",
          "Postoperative",
          "Gawande"
      ]
  },
  {
      "name": "Schwartz Pediatric Bedside eGFR  (2009)",
      "id": "calculator_281",
      "description": "The revised \"bedside\" pediatric eGFR requires only serum creatinine and height.",
      "categories": [
          "Nephrology",
          "Pediatrics"
      ],
      "tags": [
          "eGFR",
          "GFR",
          "creatinine",
          "clearance",
          "Schwartz",
          "cystatin"
      ]
  },
  {
      "name": "Schwartz Pediatric eGFR, Full Model  (2009)",
      "id": "calculator_282",
      "description": "The full Schwartz pediatric eGFR calculation requires height, serum creatinine, cystatin C, blood urea nitrogen and gender.",
      "categories": [
          "Nephrology",
          "Pediatrics"
      ],
      "tags": []
  },
  {
      "name": "VSGNE Ruptured Abdominal Aortic Aneurysm (RAAA) Risk Score",
      "id": "calculator_284",
      "description": "Estimate mortality after open repair of ruptured AAA",
      "categories": [
          "Emergency",
          "Vascular Surgery",
          "Anesthesiology"
      ],
      "tags": [
          "AAA",
          "rAAA"
      ]
  },
  {
      "name": "Euroscore II",
      "id": "calculator_285",
      "description": "Estimate risk of in-hospital death after cardiac surgery.",
      "categories": [
          "Cardiac Surgery"
      ],
      "tags": [
          "CABG",
          "euroscore",
          "MVR",
          "AVR"
      ]
  },
  {
      "name": "3-Month Mortality in Incident Elderly ESRD Patients",
      "id": "calculator_286",
      "description": "Estimate the risk of early death (at 3 months) in elderly patients starting dialysis.",
      "categories": [
          "Nephrology",
          "Geriatrics"
      ],
      "tags": [
          "dialysis",
          "mortality",
          "hemodialysis",
          "hd",
          "ESRD"
      ]
  },
  {
      "name": "Pre-test probability of CAD (CAD consortium)",
      "id": "calculator_287",
      "description": "Determine pre-test probability of coronary artery disease in patients with chest pain.",
      "categories": [
          "Cardiology",
          "Emergency",
          "Anesthesiology"
      ],
      "tags": []
  },
  {
      "name": "ASDAS-CRP (Ankylosing Spondylitis Disease Activity Score)",
      "id": "calculator_290",
      "description": "Assess disease activity in Ankylosing Spondylitis.",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "AS",
          "CRP",
          "Ankylosing",
          "Spondylitis"
      ]
  },
  {
      "name": "ASDAS-ESR (Ankylosing Spondylitis Disease Activity Score)",
      "id": "calculator_291",
      "description": "Assess disease activity in Ankylosing Spondylitis.",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "AS",
          "ESR",
          "Ankylosing",
          "Spondylitis"
      ]
  },
  {
      "name": "Predicting 3 Year Survival for Incident Elderly ESRD Patients",
      "id": "calculator_292",
      "description": "Determine appropriateness for transplant referral in elderly patients starting dialysis",
      "categories": [
          "Nephrology",
          "Geriatrics",
          "Transplant"
      ],
      "tags": []
  },
  {
      "name": "Diffuse Large B-cell Lymphoma Prognosis (IPI24)",
      "id": "calculator_293",
      "description": "Determine prognosis in diffuse large B-cell lymphoma.",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "prognosis",
          "DLBCL",
          "IPI",
          "ipi24",
          "nomogram",
          "Diffuse Large B-cell Lymphoma"
      ]
  },
  {
      "name": "Aortic Stenosis Risk Score",
      "id": "calculator_294",
      "description": "Estimate risk of cardiovascular events in patients with aortic stenosis",
      "categories": [
          "Cardiology",
          "Cardiac Surgery"
      ],
      "tags": [
          "aortic",
          "AS",
          "stenosis"
      ]
  },
  {
      "name": "Ottawa SAH Inclusion & Exclusion",
      "id": "calculator_295",
      "description": null,
      "categories": ["General Calculators"],
      "tags": []
  },
  {
      "name": "Ottawa SAH Rule",
      "id": "calculator_296",
      "description": "Use the Ottawa SAH Rule to rule out subarachnoid hemorrhage",
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "hemorrhage",
          "SAH",
          "subarachnoid",
          "headache"
      ]
  },
  {
      "name": "BASDAI",
      "id": "calculator_299",
      "description": "Assess disease activity in Ankylosing Spondylitis",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "AS",
          "Ankylosing",
          "Spondylitis",
          "BASDAI"
      ]
  },
  {
      "name": "Vasculitis Damage Index (VDI)",
      "id": "calculator_302",
      "description": "Document any organ damage that has occurred in patients since the onset of vasculitis",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "index",
          "GPA",
          "MPA",
          "ANCA",
          "Vasculitis",
          "VDI"
      ]
  },
  {
      "name": "HCM Risk-SCD",
      "id": "calculator_303",
      "description": "Assess risk of sudden cardiac death and need for ICD in hypertrophic cardiomyopathy",
      "categories": [
          "Cardiology"
      ],
      "tags": []
  },
  {
      "name": "Kidney Failure Risk Equation (4 Variable)",
      "id": "calculator_308",
      "description": "Estimate risk of progression to end-stage renal disease in CKD patients using age, sex, eGFR and proteinuria with KFRE",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "ckd",
          "kidney",
          "dialysis",
          "failure",
          "eGFR",
          "Transplant",
          "ESRD",
          "kfre"
      ]
  },
  {
      "name": "Diffuse Large B-cell Lymphoma Prognosis (NCCN-IPI)",
      "id": "calculator_311",
      "description": "Estimate prognosis in diffuse large B-cell lymphoma",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "prognosis",
          "DLBCL",
          "rituximab",
          "lymphoma"
      ]
  },
  {
      "name": "CAM-ICU",
      "id": "calculator_312",
      "description": "Diagnose delirium in the intensive care unit.",
      "categories": [
          "Neurology / Neurosurgery",
          "Critical Care"
      ],
      "tags": [
          "care",
          "intensive",
          "delirium"
      ]
  },
  {
      "name": "The Richmond Agitation Sedation Score (RASS)",
      "id": "calculator_313",
      "description": "Assess level of consciousness in the intensive care unit.",
      "categories": [
          "Neurology / Neurosurgery",
          "Critical Care"
      ],
      "tags": []
  },
  {
      "name": "Bleeding Risk in Atrial Fibrillation: ATRIA ",
      "id": "calculator_314",
      "description": "Estimate bleeding risk for patients on warfarin.",
      "categories": [
          "Cardiology",
          "Geriatrics"
      ],
      "tags": [
          "Warfarin",
          "Bleeding",
          "Afib",
          "AF",
          "atrial fib"
      ]
  },
  {
      "name": "DIPSS Plus Score for Prognosis in Myelofibrosis",
      "id": "calculator_315",
      "description": "Estimate prognosis in myelofibrosis.",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "Myelofibrosis",
          "DIPPS",
          "Plus"
      ]
  },
  {
      "name": "GAD-7 Anxiety Scale",
      "id": "calculator_317",
      "description": "Screen for generalized anxiety disorder",
      "categories": [
          "Mental Health",
          "Geriatrics"
      ],
      "tags": [
          "generalized",
          "anxiety",
          "PTSD",
          "panic",
          "social",
          "GAD"
      ]
  },
  {
      "name": "Polymyalgia Rheumatica (2012 EULAR/ACR Provisional Criteria)",
      "id": "calculator_318",
      "description": "Review EULAR/ACR criteria for polymyalgia rheumatica",
      "categories": [
          "Rheumatology",
          "Geriatrics"
      ],
      "tags": [
          "pain",
          "steroid",
          "CRP",
          "ESR",
          "PMR",
          "Shoulder",
          "Steroids"
      ]
  },
  {
      "name": "Scleroderma/Systemic Sclerosis (2013 EULAR/ACR Criteria)",
      "id": "calculator_319",
      "description": "Review EULAR/ACR criteria for scleroderma",
      "categories": [
          "Rheumatology"
      ],
      "tags": []
  },
  {
      "name": "San Francisco Syncope Rule",
      "id": "calculator_321",
      "description": "Identify those at low risk of adverse outcome after a syncopal episode",
      "categories": [
          "Cardiology",
          "Geriatrics"
      ],
      "tags": [
          "Syncope"
      ]
  },
  {
      "name": "Respiratory Adverse Event Risk Post Vascular Surgery",
      "id": "calculator_325",
      "description": "Estimate the risk of pneumonia or respiratory failure after vascular surgery",
      "categories": [
          "Respirology",
          "Vascular Surgery",
          "Anesthesiology"
      ],
      "tags": [
          "vascular",
          "Surgery",
          "failure",
          "respiratory",
          "Pneumonia",
          "VQI",
          "resp"
      ]
  },
  {
      "name": "FIB-4 for Noninvasive Diagnosis of Hepatic Fibrosis",
      "id": "calculator_326",
      "description": "Non-invasively identify hepatic fibrosis",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "Hepatitis",
          "cirrhosis",
          "fibrosis",
          "hep",
          "hep C",
          "hepatitis C",
          "ast",
          "alt",
          "platelets"
      ]
  },
  {
      "name": "APRI (AST to Platelet Ratio Index)",
      "id": "calculator_327",
      "description": "Assess likelihood of fibrosis or cirrhosis non-invasively using AST and platelet count.",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "Hepatitis",
          "liver",
          "cirrhosis",
          "platelet",
          "fibrosis",
          "hepatitis C",
          "ast",
          "nafld",
          "nash",
          "hepatic",
          "steatosis",
          "apri"
      ]
  },
  {
      "name": "PERC Rule for Pulmonary Embolism",
      "id": "calculator_330",
      "description": "Use the PERC rule to rule out PE if no criteria are present and pre-test probability is &lt;15%.",
      "categories": [
          "Emergency",
          "Urology",
          "Respirology",
          "Hematology",
          "Medical Imaging"
      ],
      "tags": [
          "Pulmonary",
          "DVT",
          "PE",
          "embolism",
          "wells",
          "Well",
          "Well's",
          "d-dimer",
          "PERC"
      ]
  },
  {
      "name": "RPDAI (Relapsing Polychondritis Disease Activity Index)",
      "id": "calculator_332",
      "description": "Assess disease activity in relapsing polychondritis.",
      "categories": [
          "Cardiology",
          "Rheumatology"
      ],
      "tags": [
          "RP",
          "relapsing",
          "polychondritis"
      ]
  },
  {
      "name": "Revised Venous Clinical Severity Score",
      "id": "calculator_333",
      "description": "Assess severity of venous disease.",
      "categories": [
          "Vascular Surgery"
      ],
      "tags": [
          "Severity",
          "revised",
          "vein",
          "VCSS",
          "venous",
          "reflux"
      ]
  },
  {
      "name": "BISAP Score",
      "id": "calculator_334",
      "description": "Estimate disease severity in acute pancreatitis.",
      "categories": [
          "Gastroenterology",
          "Critical Care"
      ],
      "tags": [
          "APACHE",
          "pancreatitis",
          "pancreas",
          "ranson",
          "ransom"
      ]
  },
  {
      "name": "SLEDAI-2K",
      "id": "calculator_335",
      "description": "Assess disease activity in lupus",
      "categories": [
          "Nephrology",
          "Rheumatology"
      ],
      "tags": [
          "Lupus",
          "SLE",
          "SLEDAI",
          "2K"
      ]
  },
  {
      "name": "Crohn's Disease Activity Index (CDAI)",
      "id": "calculator_337",
      "description": "Assess disease activity in Crohn's disease",
      "categories": [
          "Gastroenterology",
          "Surgery"
      ],
      "tags": [
          "Disease",
          "CDAI",
          "crohn",
          "crohns",
          "crohn's",
          "ibd",
          "inflammatory",
          "bowel",
          "colitis"
      ]
  },
  {
      "name": "International Prostate Symptom Score (IPSS)",
      "id": "calculator_338",
      "description": "Assess severity of symptoms in benign prostatic hypertrophy",
      "categories": [
          "Urology",
          "Geriatrics"
      ],
      "tags": [
          "IPSS",
          "prostate",
          "bph",
          "boo",
          "bladder",
          "nocturia",
          "void",
          "voiding",
          "AUASS"
      ]
  },
  {
      "name": "Mayo Early Screen for Discharge Planning",
      "id": "calculator_339",
      "description": "Identify patients needing specialized discharge planning services",
      "categories": [
          "Medical Administration"
      ],
      "tags": [
          "Mayo",
          "Rankin",
          "discharge",
          "planning"
      ]
  },
  {
      "name": "Mayo Score for Ulcerative Colitis Activity",
      "id": "calculator_340",
      "description": "Assess disease activity in ulcerative colitis",
      "categories": [
          "Gastroenterology",
          "Surgery"
      ],
      "tags": [
          "Mayo",
          "ibd",
          "colitis",
          "UC",
          "ulcerative"
      ]
  },
  {
      "name": "NAFLD Fibrosis Score",
      "id": "calculator_341",
      "description": "Reduce the need for liver biopsy by identifying patients with non-alcoholic fatty liver disease likely or unlikely to have advanced fibrosis",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "liver",
          "cirrhosis",
          "delivery",
          "fibrosis",
          "nafld",
          "nash"
      ]
  },
  {
      "name": "Dialysis Duration Needed for Methanol Ingestion",
      "id": "calculator_342",
      "description": "Estimate dialysis duration required for methanol poisoning",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "dialysis",
          "clearance",
          "urea",
          "methanol",
          "MeOH",
          "overdose"
      ]
  },
  {
      "name": "Dialysis Duration Needed for Ethylene Glycol Ingestion",
      "id": "calculator_343",
      "description": "Estimate dialysis duration required for ethylene glycol poisoning",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "dialysis",
          "ethylene",
          "glycol",
          "overdose",
          "EG"
      ]
  },
  {
      "name": "Total Body Water (Watson Formula)",
      "id": "calculator_344",
      "description": null,
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "Water",
          "TBW",
          "total body water",
          "watson"
      ]
  },
  {
      "name": "NEXUS Chest Decision Instrument for Blunt Chest Trauma",
      "id": "calculator_345",
      "description": "Assess the need for chest imaging after blunt trauma",
      "categories": [
          "Surgery",
          "Medical Imaging"
      ],
      "tags": [
          "trauma",
          "NEXUS",
          "Chest"
      ]
  },
  {
      "name": "Chronic Kidney Disease Management: BC Guidelines",
      "id": "calculator_347",
      "description": "Primary care management of CKD",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "ckd",
          "dialysis",
          "BC",
          "proteinuria",
          "ESRD",
          "ACR",
          "kfre",
          "shared"
      ]
  },
  {
      "name": "Mobilization of Hospitalized Patients with COPD Exacerbation (AECOPD-MOB)",
      "id": "calculator_348",
      "description": null,
      "categories": [
          "Physical Medicine and Rehabilitation",
          "Physiotherapy"
      ],
      "tags": []
  },
  {
      "name": "HOSPITAL Score",
      "id": "calculator_353",
      "description": "Determine risk of avoidable hospital readmission",
      "categories": [
          "Medical Administration"
      ],
      "tags": [
          "admission",
          "preventative",
          "PAR",
          "readmission",
          "hospital"
      ]
  },
  {
      "name": "Multiple Myeloma Prognosis (R-ISS)",
      "id": "calculator_354",
      "description": "Revised international staging system for myeloma",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "Myeloma",
          "ISS",
          "R-ISS",
          "chromosome",
          "CA",
          "LDH"
      ]
  },
  {
      "name": "Injury Severity Score",
      "id": "calculator_356",
      "description": "Describe severity of traumatic injury",
      "categories": [
          "Emergency",
          "Orthopedics",
          "Surgery"
      ],
      "tags": [
          "trauma",
          "ISS",
          "Traumatic"
      ]
  },
  {
      "name": "Brain Metastases Prognostic Index",
      "id": "calculator_357",
      "description": "Estimate prognosis in patients with brain metastases using the graded prognostic assessment",
      "categories": [
          "Oncology"
      ],
      "tags": [
          "mets",
          "Brain",
          "met",
          "metastasis",
          "metastases"
      ]
  },
  {
      "name": "MELD Score - Age above 12 years",
      "id": "calculator_359",
      "description": "Scoring system used to rank prioritize candidates for liver transplantation, including MELD-Na used in the OPTN match system",
      "categories": [
          "Infectious Disease",
          "Gastroenterology",
          "Transplant"
      ],
      "tags": [
          "MELD",
          "Sodium",
          "Transplant",
          "MELDNa",
          "MELD-Na",
          "INR",
          "Bilirubin"
      ]
  },
  {
      "name": "Corrected Sodium in Hyperglycemia",
      "id": "calculator_360",
      "description": "As used in the new MELD score, to correct Na in the setting of hyperglycemia",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "Sodium",
          "na",
          "glucose",
          "hyponatremia",
          "hyperglycemia",
          "glc"
      ]
  },
  {
      "name": "Pediatric Renal Angina Index",
      "id": "calculator_361",
      "description": "Predict acute kidney injury in critically ill children",
      "categories": [
          "Nephrology",
          "Critical Care"
      ],
      "tags": []
  },
  {
      "name": "STARRT-AKI Enrollment Criteria",
      "id": "calculator_362",
      "description": "Determine if patients meet criteria for the STARRT-AKI study.",
      "categories": [
          "Nephrology",
          "Critical Care"
      ],
      "tags": []
  },
  {
      "name": "Serious Illness Conversation Guide",
      "id": "calculator_364",
      "description": "Steps to elicit important information from your patients about their goals and values",
      "categories": [
          "Oncology",
          "Critical Care"
      ],
      "tags": [
          "ariedne",
          "Serious Illness Care"
      ]
  },
  {
      "name": "Kinetic eGFR (KeGFR)",
      "id": "calculator_367",
      "description": "Estimate GFR when creatinine is changing acutely (either rising or falling)",
      "categories": [
          "Nephrology",
          "Critical Care"
      ],
      "tags": [
          "dialysis",
          "eGFR",
          "CKDEPI",
          "GFR",
          "AKI",
          "acute",
          "hd",
          "Injury",
          "renal failure",
          "crrt",
          "ihd",
          "sled",
          "sledd",
          "oliguria",
          "anuria"
      ]
  },
  {
      "name": "PIM2",
      "id": "calculator_368",
      "description": "Paediatric Index of Mortality, revised version",
      "categories": [
          "Nephrology",
          "Pediatrics",
          "Critical Care"
      ],
      "tags": []
  },
  {
      "name": "Base Excess",
      "id": "calculator_369",
      "description": "Used in assessing acid-base status",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "base",
          "pH",
          "Metabolic",
          "excess"
      ]
  },
  {
      "name": "Serious Renal Dysfunction Post-PCI",
      "id": "calculator_371",
      "description": "Assess risk of dialysis or severe increase in creatinine after PCI",
      "categories": [
          "Nephrology",
          "Critical Care"
      ],
      "tags": []
  },
  {
      "name": "DAPT Score",
      "id": "calculator_373",
      "description": "Which patients should remain on dual anti-platelet therapy 1 year following coronary stent treatment?",
      "categories": [
          "Cardiology"
      ],
      "tags": []
  },
  {
      "name": "PCDAI",
      "id": "calculator_374",
      "description": "Pediatric Crohn's Disease Activity Index",
      "categories": [
          "Pediatrics",
          "Gastroenterology"
      ],
      "tags": [
          "crohn",
          "crohns",
          "crohn's",
          "PCDAI",
          "crohns'"
      ]
  },
  {
      "name": "CLL-IPI",
      "id": "calculator_375",
      "description": "The International Prognostic Index for patients with chronic lymphocytic leukemia",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "CLL",
          "CLL-IPI",
          "chronic lymphocytic leukemia"
      ]
  },
  {
      "name": "Modified Marshall Score",
      "id": "calculator_376",
      "description": "A definition of organ failure in acute pancreatitis",
      "categories": [
          "Gastroenterology",
          "Surgery"
      ],
      "tags": [
          "pancreatitis",
          "pancreas",
          "Atlanta",
          "Marshall"
      ]
  },
  {
      "name": "International Index of Erectile Function (IIEF-5)",
      "id": "calculator_377",
      "description": "Assess erectile dysfunction",
      "categories": [
          "Urology"
      ],
      "tags": [
          "ED",
          "erectile",
          "dysfunction",
          "ieff",
          "ieff-5"
      ]
  },
  {
      "name": "CRRT Dosing Calculator",
      "id": "calculator_378",
      "description": "Calculate desired dose of dialysate in CRRT",
      "categories": [
          "Nephrology",
          "Critical Care"
      ],
      "tags": [
          "dialysis",
          "crrt",
          "dose"
      ]
  },
  {
      "name": "Modified Glasgow Imrie Severity Criteria for Acute Pancreatitis",
      "id": "calculator_379",
      "description": "Predict outcome in acute pancreatitis",
      "categories": [
          "Emergency",
          "Gastroenterology",
          "Surgery",
          "Critical Care"
      ],
      "tags": [
          "pancreatitis",
          "Glasgow",
          "imrie"
      ]
  },
  {
      "name": "Canadian Syncope Risk Score (CSRS)",
      "id": "calculator_383",
      "description": "Estimate prognosis among patients presenting to emergency with syncope",
      "categories": [
          "Cardiology",
          "Emergency",
          "Geriatrics"
      ],
      "tags": [
          "Syncope",
          "death",
          "Serious adverse event",
          "arrhythmia",
          "CSRS"
      ]
  },
  {
      "name": "Expected spleen size ",
      "id": "calculator_384",
      "description": "Provides upper limit of normal for spleen length and volume by ultrasound relative to body height and gender.\r\n",
      "categories": [
          "Hematology",
          "Medical Imaging",
          "Pathology & Lab Medicine"
      ],
      "tags": []
  },
  {
      "name": "NCDR AKI and Dialysis Risk after PCI",
      "id": "calculator_386",
      "description": "Estimate risk of AKI and dialysis after PCI",
      "categories": [
          "Cardiology",
          "Nephrology"
      ],
      "tags": [
          "dialysis",
          "PCI",
          "Cardiac",
          "Contrast",
          "AKI",
          "cath"
      ]
  },
  {
      "name": "ADPKD Prognostic Tool using Total Kidney Volume",
      "id": "calculator_387",
      "description": "Estimate risk of progression in Autosomal Dominant Polycystic Kidney Disease",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "Mayo",
          "PKD",
          "ADPKD"
      ]
  },
  {
      "name": "Padua Prediction Score for Risk of VTE",
      "id": "calculator_388",
      "description": "Estimate risk of venous thromboembolism in hospitalized patients",
      "categories": [
          "Hematology"
      ],
      "tags": []
  },
  {
      "name": "30-Day Stroke Risk Index for CEA",
      "id": "calculator_389",
      "description": "Estimate risk of stroke within 30 days after carotid endarterectomy",
      "categories": [
          "Neurology / Neurosurgery",
          "Vascular Surgery",
          "Anesthesiology"
      ],
      "tags": [
          "Risk",
          "stroke",
          "carotid",
          "VQI",
          "CEA"
      ]
  },
  {
      "name": "1-Year Mortality Risk Index for CEA",
      "id": "calculator_390",
      "description": "Estimate probability of death within 1 year after carotid endarterectomy",
      "categories": [
          "Neurology / Neurosurgery",
          "Vascular Surgery",
          "Anesthesiology"
      ],
      "tags": [
          "mortality",
          "carotid",
          "VQI",
          "CEA"
      ]
  },
  {
      "name": "MDS Revised - International Prognostic Scoring System (IPSS-R)  Non-Age Adjusted",
      "id": "calculator_396",
      "description": "Assess mortality and progression to acute myeloid leukemia in myelodysplastic syndrome using the non-age adjusted model",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "hematology",
          "heme",
          "oncology",
          "Prognostic",
          "Scoring",
          "International",
          "MDS",
          "Intnl",
          "IPSS",
          "IPSSR",
          "myelodysplastic",
          "syndrome",
          "system",
          "WPSS",
          "IPSS-R"
      ]
  },
  {
      "name": "Short Michigan Alcoholism Screening Test-geriatric version The SMAST-G",
      "id": "calculator_426",
      "description": "Assess for problem alcohol drinking in the elderly",
      "categories": [
          "Mental Health",
          "Geriatrics"
      ],
      "tags": []
  },
  {
      "name": "CNS International Prognostic Index in Diffuse Large B-Cell Lymphoma (CNS-IPI)",
      "id": "calculator_428",
      "description": "Estimate risk of CNS relapse/progression in diffuse large B-cell lymphoma",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": []
  },
  {
      "name": "MALT Lymphoma prognosis (MALT-IPI)",
      "id": "calculator_429",
      "description": "Estimate prognosis in MALT lymphoma",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": []
  },
  {
      "name": "Khorana risk score",
      "id": "calculator_433",
      "description": "Estimate risk of chemotherapy-associated thrombosis",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": []
  },
  {
      "name": "PORT score for PeriOperative Risk of blood Transfusion in cardiac surgery by ACTA",
      "id": "calculator_436",
      "description": "Predict risk of blood transfusion after elective cardiac surgery using the ACTA-PORT score",
      "categories": [
          "Hematology",
          "Cardiac Surgery",
          "Anesthesiology"
      ],
      "tags": []
  },
  {
      "name": "ROKS – Recurrence Of Kidney Stone (2018)",
      "id": "calculator_438",
      "description": "Predict the risk of a future symptomatic kidney stone after the last symptomatic stone.",
      "categories": [
          "Nephrology",
          "Urology"
      ],
      "tags": []
  },
  {
      "name": "MIDAS (Migraine Disability Assessment)",
      "id": "calculator_439",
      "description": "Measure level of disability in patients with migraines\r\n",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "headache",
          "migraine",
          "midas"
      ]
  },
  {
      "name": "ADPKD Prognostic Tool using Kidney Dimensions",
      "id": "calculator_440",
      "description": "Estimate risk of progression in Autosomal Dominant Polycystic Kidney Disease",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "Mayo",
          "PKD",
          "ADPKD"
      ]
  },
  {
      "name": "UKELD Score",
      "id": "calculator_442",
      "description": "The United Kingdom Model for End-Stage Liver Disease (UKELD)  predicts prognosis in chronic liver disease and can be used to prioritize for liver transplantation",
      "categories": [
          "Gastroenterology",
          "Critical Care",
          "Transplant"
      ],
      "tags": []
  },
  {
      "name": "Euroscore: Additive Score",
      "id": "calculator_445",
      "description": null,
      "categories": ["General Calculators"],
      "tags": [
          "cardiology",
          "Risk",
          "prognosis",
          "Surgery",
          "Cardiac",
          "cv",
          "cardiovascular",
          "euroscore"
      ]
  },
  {
      "name": "Predicting 6 and 12 Month Mortality in CKD patients",
      "id": "calculator_446",
      "description": "Estimate mortality in patients with stage IV or V chronic kidney disease.",
      "categories": [
          "Nephrology",
          "Transplant"
      ],
      "tags": []
  },
  {
      "name": "Geriatric-Sensitive Perioperative Cardiac Risk Index | GSCRI",
      "id": "calculator_448",
      "description": "Estimate risk of perioperative myocardial infarction or cardiac arrest in patients over 65",
      "categories": [
          "Cardiology",
          "Urology",
          "Surgery",
          "Anesthesiology",
          "Geriatrics"
      ],
      "tags": [
          "Risk",
          "MI",
          "myocardial",
          "infarction",
          "index",
          "Cardiac",
          "cardiovascular",
          "VSG",
          "carotid",
          "endarterectomy",
          "abdominal",
          "new england"
      ]
  },
  {
      "name": "Vancomycin Dosing Based on eGFR (creatinine-cystatin C)",
      "id": "calculator_449",
      "description": "Select an appropriate initial dose and interval for vancomycin taking into account renal function using cystatin C & creatinine",
      "categories": [
          "Nephrology",
          "Infectious Disease"
      ],
      "tags": []
  },
  {
      "name": "Advanced CKD after AKI Risk Index",
      "id": "calculator_451",
      "description": "Estimate risk of advanced chronic kidney disease after acute kidney injury",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "ckd",
          "creatinine",
          "AKI",
          "KDIGO",
          "cr",
          "chronic kidney disease"
      ]
  },
  {
      "name": "Mayo AKI Risk after Primary Total Hip Arthroplasty",
      "id": "calculator_455",
      "description": "Estimate perioperative risk of acute kidney injury",
      "categories": [
          "Nephrology",
          "Orthopedics"
      ],
      "tags": [
          "AKI",
          "Mayo",
          "THA",
          "total hip arthroplasty"
      ]
  },
  {
      "name": "ROSIER scale",
      "id": "calculator_457",
      "description": "Determine which patients are likely to have true stroke vs stroke mimics",
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "Patient Health Questionnaire-2 (PHQ-2)",
      "id": "calculator_458",
      "description": "Ultra-brief screening for depressive disorders",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "ADviSED - Aortic Dissection Detection Risk Score Plus D-Dimer for Aortic Syndromes",
      "id": "calculator_459",
      "description": "Rule out aortic dissection and other aortic syndromes",
      "categories": [
          "Cardiology",
          "Emergency",
          "Cardiac Surgery",
          "Vascular Surgery"
      ],
      "tags": [
          "aortic",
          "aorta",
          "d-dimer",
          "dissection",
          "advised",
          "aortic syndrome",
          "ADD-RS"
      ]
  },
  {
      "name": "Patient Health Questionnaire-15 (PHQ-15)",
      "id": "calculator_460",
      "description": "Somatic Symptom Severity Scale",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Modified Early Warning Score (MEWS)",
      "id": "calculator_461",
      "description": "Identify patients who are at risk of clinical deterioration and who may require a higher level of care.",
      "categories": [
          "Emergency",
          "Critical Care"
      ],
      "tags": []
  },
  {
      "name": "PHASES Score",
      "id": "calculator_464",
      "description": "Predict risk of rupture for asymptomatic intracranial aneurysms",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "Seizure vs Syncope",
      "id": "calculator_466",
      "description": "Determine which patients are likely to have seizure versus syncope as the cause of loss of consciousness\r\n",
      "categories": [
          "Neurology / Neurosurgery",
          "Geriatrics"
      ],
      "tags": []
  },
  {
      "name": "Altman Self-Rating Mania Scale (ASRM)",
      "id": "calculator_468",
      "description": "5 question scale to screen and stage severity of hypomania/mania",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Postoperative Mortality Rate After Elective AAA",
      "id": "calculator_469",
      "description": "Estimate risk of mortality after elective AAA repair",
      "categories": [
          "Vascular Surgery"
      ],
      "tags": []
  },
  {
      "name": "Alcohol Use Disorders Identification Test-Concise (AUDIT-C)",
      "id": "calculator_470",
      "description": "Brief screen to detecting heavy alcohol use",
      "categories": [
          "Mental Health",
          "Addiction Medicine"
      ],
      "tags": []
  },
  {
      "name": "Young Mania Rating Scale (YMRS)",
      "id": "calculator_473",
      "description": "11 question scale to grade the severity of mania",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Alcohol Use Disorders Identification Test (AUDIT)",
      "id": "calculator_474",
      "description": "Screen for active alcohol abuse or dependence",
      "categories": [
          "Mental Health",
          "Addiction Medicine"
      ],
      "tags": []
  },
  {
      "name": "Patient Health Questionnaire-4 (PHQ-4)",
      "id": "calculator_476",
      "description": "Ultra-Brief Screening for Anxiety and Depression",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Urine Anion Gap or Urine Net Charge",
      "id": "calculator_477",
      "description": "Use urine electrolytes to differentiate renal tubular acidosis from diarrhea-induced non-anion gap metabolic acidosis",
      "categories": [
          "Nephrology",
          "Gastroenterology"
      ],
      "tags": [
          "acidosis",
          "Urine",
          "na",
          "K",
          "UAG",
          "net",
          "charge",
          "Cl",
          "RTA",
          "diarrhea",
          "NAGMA"
      ]
  },
  {
      "name": "CAGE Questionnaire",
      "id": "calculator_481",
      "description": "4 question screening for alcohol problems",
      "categories": [
          "Mental Health",
          "Addiction Medicine"
      ],
      "tags": []
  },
  {
      "name": "Multiple Sclerosis: Diagnosis",
      "id": "calculator_482",
      "description": "Diagnose MS using the 2017 McDonald Criteria",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "MS"
      ]
  },
  {
      "name": "Lille Model for Alcoholic Hepatitis",
      "id": "calculator_483",
      "description": "Estimate mortality in patients with severe alcoholic hepatitis not responding to corticosteroid therapy\r\n",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "Hepatitis",
          "Corticosteroid",
          "steroid",
          "alcoholic",
          "Steroids",
          "maddrey",
          "transaminitis"
      ]
  },
  {
      "name": "CLL BALL Score for Relapsed/Refractory CLL",
      "id": "calculator_485",
      "description": null,
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": []
  },
  {
      "name": "Mean Arterial Pressure (MAP) ",
      "id": "calculator_486",
      "description": "Calculate MAP",
      "categories": [
          "Emergency",
          "Critical Care"
      ],
      "tags": [
          "Pressure",
          "MAP",
          "Systolic",
          "BP",
          "diastolic",
          "mean"
      ]
  },
  {
      "name": "Smith-Modified Sgarbossa’s Criteria for MI in Left Bundle Branch Block",
      "id": "calculator_487",
      "description": "Diagnose acute MI in patients with known LBBB ",
      "categories": [
          "Emergency"
      ],
      "tags": []
  },
  {
      "name": "Sgarbossa’s Criteria for MI in Left Bundle Branch Block",
      "id": "calculator_488",
      "description": "Allows for the diagnosis of acute MI in patients with known LBBB ",
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "STEMI",
          "LBBB"
      ]
  },
  {
      "name": "Centor Score (modified) for GAS Pharyngitis",
      "id": "calculator_489",
      "description": "Estimate likelihood of GAS pharyngitis",
      "categories": [
          "Emergency",
          "Infectious Disease",
          "Pediatrics"
      ],
      "tags": []
  },
  {
      "name": "Total Kidney Volume (height-adjusted) Calculator & ADPKD Prognostic Tool using Kidney Dimensions",
      "id": "calculator_490",
      "description": "Estimate risk of progression in Autosomal Dominant Polycystic Kidney Disease using kidney dimensions",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "Mayo",
          "PKD",
          "ADPKD"
      ]
  },
  {
      "name": "ADPKD Prognostic Tool using Total Kidney Volume",
      "id": "calculator_491",
      "description": "Estimate risk of progression in Autosomal Dominant Polycystic Kidney Disease using total kidney volume",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "Mayo",
          "PKD",
          "ADPKD"
      ]
  },
  {
      "name": "Edinburgh Postnatal Depression Scale (EPDS)",
      "id": "calculator_494",
      "description": "10 question screener for postpartum depression",
      "categories": [
          "Obstetrics & Gynecology",
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Philadelphia Criteria in Febrile Infants  ",
      "id": "calculator_495",
      "description": "Identify febrile infants aged 29 – 56 days old who are lower risk for serious bacterial infection  ",
      "categories": [
          "Emergency",
          "Infectious Disease",
          "Pediatrics"
      ],
      "tags": []
  },
  {
      "name": "Boston Criteria for Febrile Infants",
      "id": "calculator_497",
      "description": "Identify febrile infants aged 28 – 89 days old who are lower risk for serious bacterial infection  ",
      "categories": [
          "Emergency",
          "Infectious Disease",
          "Pediatrics"
      ],
      "tags": []
  },
  {
      "name": "Rochester Criteria for Febrile Infants",
      "id": "calculator_498",
      "description": "Identify febrile infants aged &le; 60 days old who are low-risk for serious bacterial infection",
      "categories": [
          "Emergency",
          "Infectious Disease",
          "Pediatrics"
      ],
      "tags": [
          "Fever",
          "rochester"
      ]
  },
  {
      "name": "International IgAN Prediction Tool at biopsy - Adults",
      "id": "calculator_499",
      "description": "Determine prognosis in adults with IgA nephropathy",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "iga",
          "igan"
      ]
  },
  {
      "name": "PECARN Rule for Pediatric Head Injury &lt; 2 years old",
      "id": "calculator_500",
      "description": "Assess the need for neuroimaging in pediatric head trauma ",
      "categories": [
          "Emergency",
          "Pediatrics"
      ],
      "tags": []
  },
  {
      "name": "PECARN Rule for Pediatric Head Injury &ge; 2 years old",
      "id": "calculator_501",
      "description": "Assess the need for neuroimaging in pediatric head trauma ",
      "categories": [
          "Emergency",
          "Pediatrics"
      ],
      "tags": []
  },
  {
      "name": "BE3A Score",
      "id": "calculator_502",
      "description": "When to treat HCV in decompensated cirrhosis",
      "categories": [
          "Infectious Disease",
          "Gastroenterology"
      ],
      "tags": [
          "Hepatitis",
          "cirrhosis",
          "hep",
          "HepC"
      ]
  },
  {
      "name": "Reducing Vascular Risk in Patients Living with Diabetes",
      "id": "calculator_503",
      "description": "Determine which patients with diabetes require vascular protective therapy",
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "Risk",
          "diabetes",
          "vascular",
          "cardiovascular",
          "CVD",
          "reduction",
          "complication",
          "a1c",
          "hba1c",
          "dm",
          "dm2",
          "medication",
          "protective",
          "t2d",
          "t1d",
          "t2dm",
          "mellitus",
          "t1dm",
          "diabetes canada",
          "eli lilly",
          "asa",
          "statin",
          "ace",
          "arb",
          "liraglutide",
          "empagliflozin",
          "canagliflozin"
      ]
  },
  {
      "name": "Bipolar Spectrum Diagnostic Scale (BSDS)",
      "id": "calculator_504",
      "description": "20 question screener for bipolar spectrum diagnosis",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "NSAID risk of AKI or hyperkalemia",
      "id": "calculator_507",
      "description": "Calculator to predict risk of AKI or hyperkalemia within 30 days after initiation of prescription NSAIDs in adults 66 years and older.",
      "categories": [
          "Nephrology"
      ],
      "tags": []
  },
  {
      "name": "Panic Disorder Severity Scale (PDSS)",
      "id": "calculator_508",
      "description": "7 question scale to grade panic disorder severity",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Physical Activity Decision Tool for Patients Living with Diabetes",
      "id": "calculator_509",
      "description": "Assess your patient's physical ability and level of motivation to start and/or progress through a physical activity program.",
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "diabetes",
          "exercise",
          "physical",
          "Activity",
          "dm",
          "dm2",
          "t2d",
          "t1d",
          "t2dm",
          "mellitus",
          "t1dm",
          "diabetes canada",
          "eli lilly"
      ]
  },
  {
      "name": "Individualizing Your Patient's A1c Target",
      "id": "calculator_510",
      "description": "Determine a patient-specific A1C target recommendation",
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "diabetes",
          "a1c",
          "hba1c",
          "dm",
          "dm2",
          "t2d",
          "t1d",
          "t2dm",
          "mellitus",
          "t1dm",
          "diabetes canada",
          "eli lilly",
          "target",
          "individualize"
      ]
  },
  {
      "name": "Self-Monitoring Blood Glucose (SMBG)",
      "id": "calculator_511",
      "description": "Determine frequency of blood glucose monitoring",
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "diabetes",
          "Blood",
          "test",
          "glucose",
          "dm",
          "dm2",
          "t2d",
          "t1d",
          "t2dm",
          "t1dm",
          "diabetes canada",
          "eli lilly",
          "monitor",
          "self",
          "pattern",
          "sugar"
      ]
  },
  {
      "name": "Screening For And Diagnosing Diabetes - A1c and Fasting Plasma Glucose",
      "id": "calculator_512",
      "description": "Determine risk of developing diabetes and frequency of screening required",
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "Risk",
          "diabetes",
          "a1c",
          "hba1c",
          "dm",
          "dm2",
          "protective",
          "t2d",
          "t1d",
          "t2dm",
          "mellitus",
          "t1dm",
          "diabetes canada",
          "eli lilly",
          "fpg",
          "screen",
          "diagnose"
      ]
  },
  {
      "name": "Screening For And Diagnosing Diabetes - 75g Oral Glucose Tolerance Test (OGTT)",
      "id": "calculator_516",
      "description": "Determine risk of developing diabetes and frequency of screening required",
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "Risk",
          "diabetes",
          "hba1c",
          "dm",
          "dm2",
          "t2d",
          "t1d",
          "t2dm",
          "mellitus",
          "t1dm",
          "diabetes canada",
          "eli lilly",
          "screen",
          "diagnose",
          "ogtt"
      ]
  },
  {
      "name": "Car, Relax, Alone, Forget, Friends, Trouble (CRAFFT 2.1)",
      "id": "calculator_519",
      "description": "9 question screener for substance use in adolescents",
      "categories": [
          "Pediatrics",
          "Addiction Medicine"
      ],
      "tags": []
  },
  {
      "name": "TB Skin Test Interpretation",
      "id": "calculator_520",
      "description": "Determine likelihood of TB based on tuberculin skin test",
      "categories": [
          "Respirology",
          "Infectious Disease"
      ],
      "tags": [
          "TB"
      ]
  },
  {
      "name": "EVAR Short-Stay Discharge",
      "id": "calculator_521",
      "description": null,
      "categories": [
          "Vascular Surgery"
      ],
      "tags": []
  },
  {
      "name": "SIRS Criteria (Systemic Inflammatory Response Syndrome)",
      "id": "calculator_522",
      "description": "Identify systemic inflammatory response to an infectious or non-infectious insult",
      "categories": [
          "Emergency",
          "Critical Care"
      ],
      "tags": []
  },
  {
      "name": "ABC Score for Massive Transfusion",
      "id": "calculator_523",
      "description": "Predict necessity for massive transfusion in trauma patients",
      "categories": [
          "Emergency",
          "Critical Care"
      ],
      "tags": [
          "transfuse"
      ]
  },
  {
      "name": "qSOFA Score in Septic Patients",
      "id": "calculator_525",
      "description": "Predict patients at high-mortality risk from sepsis (not diagnose sepsis)",
      "categories": [
          "Emergency",
          "Infectious Disease",
          "Critical Care",
          "Anesthesiology"
      ],
      "tags": []
  },
  {
      "name": "Maintenance Fluid Calculations",
      "id": "calculator_526",
      "description": "Determine maintenance IV fluid rates",
      "categories": [
          "Emergency"
      ],
      "tags": []
  },
  {
      "name": "Erasmus GBS Respiratory Insufficiency Score (EGRIS)",
      "id": "calculator_527",
      "description": "Predict the probability of respiratory insufficiency within the first week of admission, in individual patients with Guillain-Barré syndrome. ",
      "categories": [
          "Respirology",
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "Modified Erasmus GBS Outcome Score (EGOS) at hospital admission",
      "id": "calculator_528",
      "description": "Predict probability of being unable to walk independently during follow up in patients with Guillain-Barré syndrome. Score taken at hospital admission.",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "Modified Erasmus GBS Outcome Score (EGOS) at day 7 of admission",
      "id": "calculator_529",
      "description": "Predict the probability of being unable to walk independently during follow up in patients with Guillain-Barré syndrome. Score taken after 7 days of hospital admission.",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "COWS Score for Opiate Withdrawal ",
      "id": "calculator_530",
      "description": null,
      "categories": [
          "Emergency",
          "Addiction Medicine"
      ],
      "tags": [
          "withdrawal",
          "Narcotic",
          "narcotics",
          "opioid",
          "opioids"
      ]
  },
  {
      "name": "STOP-BANG Score for Obstructive Sleep Apnea",
      "id": "calculator_531",
      "description": "Screen for obstructive sleep apnea\r\n",
      "categories": [
          "Respirology",
          "Anesthesiology"
      ],
      "tags": []
  },
  {
      "name": "Valsartan dose equivalence",
      "id": "calculator_532",
      "description": "Useful for replacing Valsartan formulations affected by the 2018 recall",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "arb",
          "valsartan",
          "diovan"
      ]
  },
  {
      "name": "PRAM Score for Pediatric Asthma Exacerbation Severity",
      "id": "calculator_534",
      "description": "Assess asthma severity in pediatric patients",
      "categories": [
          "Emergency",
          "Pediatrics"
      ],
      "tags": []
  },
  {
      "name": "Who Five Well Being Index (WHO-5)​",
      "id": "calculator_535",
      "description": "5 questions to measure mental well-being",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Dutch Meningitis Risk Score",
      "id": "calculator_536",
      "description": "The Dutch Meningitis Risk Score is a bedside risk score for unfavorable outcome in adults with bacterial meningitis. ",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "Informant Questionnaire on Cognitive Decline in the Elderly (IQCODE)",
      "id": "calculator_538",
      "description": "16 question geriatric cognitive screener",
      "categories": [
          "Mental Health",
          "Geriatrics"
      ],
      "tags": []
  },
  {
      "name": "Canadian Influenza Immunization Guide",
      "id": "calculator_540",
      "description": "Adapted from Immunize Canada",
      "categories": [
          "Infectious Disease"
      ],
      "tags": []
  },
  {
      "name": "Major Depression Inventory (MDI)",
      "id": "calculator_542",
      "description": "12 question depression severity scale",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Screening For And Diagnosing Gestational Diabetes Mellitus (GDM)",
      "id": "calculator_547",
      "description": "Assess for gestational diabetes mellitus",
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "Risk",
          "diabetes",
          "pregnancy",
          "glucose",
          "a1c",
          "hba1c",
          "dm",
          "dm2",
          "Gestational",
          "t2d",
          "t1d",
          "t2dm",
          "mellitus",
          "t1dm",
          "diabetes canada",
          "eli lilly",
          "ogtt",
          "gdm",
          "gct"
      ]
  },
  {
      "name": "Post Traumatic Stress Disorder (PCL-C)",
      "id": "calculator_548",
      "description": "17 question self-report for Post Traumatic Stress Disorder",
      "categories": [
          "Mental Health",
          "Addiction Medicine"
      ],
      "tags": [
          "PTSD"
      ]
  },
  {
      "name": "Brief Psychiatric Rating Scale (BPRS)",
      "id": "calculator_551",
      "description": "18 clinical questions to assess severity of consolidated symptoms  ",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "PML Risk Stratification in Multiple Sclerosis Patients on Natalizumab",
      "id": "calculator_555",
      "description": "Stratify risk of developing PML in patients with Multiple Sclerosis who are on natalizumab",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "Diagnosis of Dementia with Lewy Bodies (DLB)",
      "id": "calculator_556",
      "description": "Diagnose patients with dementia with Lewy Bodies based on the 2017 criteria\r\n",
      "categories": [
          "Neurology / Neurosurgery",
          "Geriatrics"
      ],
      "tags": []
  },
  {
      "name": "Ottawa chronic obstructive pulmonary disease risk scale (OCRS)",
      "id": "calculator_557",
      "description": "Guide admission vs discharge in COPD exacerbation",
      "categories": [
          "Emergency",
          "Respirology"
      ],
      "tags": [
          "COPD"
      ]
  },
  {
      "name": "Sokal Score for CML",
      "id": "calculator_559",
      "description": "Estimate survival in CML",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "chronic myelogenous leukemia"
      ]
  },
  {
      "name": "EUTOS Score for Chronic Myelogenous Leukemia (CML)",
      "id": "calculator_561",
      "description": "Predict outcomes after CML treatment, adjusted for tyrosine kinase treatments\r\n",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": []
  },
  {
      "name": "Eating Disorder Diagnostic Scale (EDDS)",
      "id": "calculator_562",
      "description": "22 questions to screen for eating disorders",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Diagnosis of Multiple System Atrophy (MSA)",
      "id": "calculator_563",
      "description": "Diagnose Multiple Systems Atrophy based on the 2008 criteria\r\n",
      "categories": [
          "Neurology / Neurosurgery",
          "Geriatrics"
      ],
      "tags": []
  },
  {
      "name": "Primary Progressive Multiple Sclerosis:  Diagnosis",
      "id": "calculator_564",
      "description": "Diagnose Primary Progressive MS using the 2017 McDonald Criteria",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "PPMS"
      ]
  },
  {
      "name": "Worklife Balance",
      "id": "calculator_565",
      "description": null,
      "categories": [
          "Medical Administration"
      ],
      "tags": []
  },
  {
      "name": "Emergency Heart Failure Mortality Risk Grade (EHMRG)",
      "id": "calculator_566",
      "description": "Risk stratify patients with acutely decompensated heart failure",
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "CHF",
          "heart failure",
          "EHMRG"
      ]
  },
  {
      "name": "Diagnosis of Progressive Supranuclear Palsy (PSP)",
      "id": "calculator_567",
      "description": "Diagnosis of Progressive Supranuclear Palsy (PSP)",
      "categories": [
          "Neurology / Neurosurgery",
          "Geriatrics"
      ],
      "tags": []
  },
  {
      "name": "Generalized Anxiety Disorder 2 (GAD-2)",
      "id": "calculator_570",
      "description": "Ultra-brief screening for anxiety disorders",
      "categories": [
          "Mental Health"
      ],
      "tags": [
          "anxiety",
          "GAD"
      ]
  },
  {
      "name": "Light's Criteria",
      "id": "calculator_571",
      "description": "Determine whether a pleural effusion is exudative or transudative",
      "categories": [
          "Emergency",
          "Respirology"
      ],
      "tags": [
          "Criteria",
          "Light",
          "pleural effusion",
          "exudative",
          "transudative",
          "pleural fluid",
          "effusion",
          "pleural",
          "thoracentesis"
      ]
  },
  {
      "name": "Pittsburgh Knee Rule",
      "id": "calculator_572",
      "description": "Assist with detection of knee fractures and decision to x-ray",
      "categories": [
          "Emergency",
          "Orthopedics"
      ],
      "tags": []
  },
  {
      "name": "Renal Cell Carcinoma TNM Staging",
      "id": "calculator_573",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Urology",
          "Oncology"
      ],
      "tags": [
          "kidney",
          "Malignancy",
          "cancer",
          "oncology",
          "renal",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "RCC",
          "metastasis",
          "metastases",
          "neoplasm",
          "renal cell carcinoma"
      ]
  },
  {
      "name": "Modified Mallampati Classification ",
      "id": "calculator_580",
      "description": "Oropharyngeal assessment used for predicting difficulty in laryngoscopy and endotracheal intubation",
      "categories": [
          "Emergency",
          "Anesthesiology"
      ],
      "tags": [
          "airway",
          "endotracheal intubation",
          "laryngoscopy",
          "mallampati"
      ]
  },
  {
      "name": "Diagnosis of Clostridium Difficile Infection",
      "id": "calculator_582",
      "description": "Based on IDSA guidelines",
      "categories": [
          "Infectious Disease",
          "Gastroenterology"
      ],
      "tags": [
          "CDI",
          "CDiff",
          "CDif",
          "CD"
      ]
  },
  {
      "name": "Treatment of First Episode of Clostridium Difficile",
      "id": "calculator_583",
      "description": "Clinical management algorithm for adults, based on IDSA guidelines",
      "categories": [
          "Infectious Disease",
          "Gastroenterology"
      ],
      "tags": []
  },
  {
      "name": "Treatment of Recurrent Episode of Clostridium Difficile",
      "id": "calculator_585",
      "description": "Clinical management algorithm for adults, based on IDSA guidelines",
      "categories": [
          "Infectious Disease",
          "Gastroenterology"
      ],
      "tags": [
          "CDI",
          "CDiff",
          "CDif",
          "CD"
      ]
  },
  {
      "name": "Breast Cancer (Clinical) TNM Staging",
      "id": "calculator_586",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Surgery"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "oncology",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "metastasis",
          "metastases",
          "neoplasm",
          "breast",
          "breast cancer",
          "mammogram",
          "tumour",
          "tumor"
      ]
  },
  {
      "name": "McMahon Rhabdomyolysis Risk Score",
      "id": "calculator_587",
      "description": "Predict the risk of severe acute kidney injury or mortality in patients with rhabdomyolysis",
      "categories": [
          "Emergency",
          "Nephrology",
          "Orthopedics"
      ],
      "tags": [
          "AKI",
          "rhabdo",
          "CK",
          "CPK"
      ]
  },
  {
      "name": "ASA Physical Status",
      "id": "calculator_589",
      "description": "Classification system for assessing the fitness of patients before surgery",
      "categories": [
          "Cardiology",
          "Urology",
          "Vascular Surgery",
          "Surgery",
          "Anesthesiology"
      ],
      "tags": [
          "Risk",
          "asa",
          "anesthesia",
          "operation"
      ]
  },
  {
      "name": "Brugada Criteria for Ventricular Tachycardia",
      "id": "calculator_591",
      "description": "ECG criteria to help differentiate ventricular tachycardia from supraventricular tachycardia.   ",
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "ECG",
          "ekg",
          "arrhythmia",
          "VT",
          "SVT"
      ]
  },
  {
      "name": "Kocher Criteria for Septic Arthritis",
      "id": "calculator_592",
      "description": "Determine risk of septic arthritis in a child with an inflamed hip",
      "categories": [
          "Emergency",
          "Infectious Disease",
          "Pediatrics",
          "Orthopedics",
          "Rheumatology"
      ],
      "tags": [
          "pediatrics",
          "emergency medicine",
          "hip",
          "septic hip"
      ]
  },
  {
      "name": "Lung Cancer TNM Staging",
      "id": "calculator_593",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Respirology",
          "Oncology"
      ],
      "tags": [
          "Pulmonary",
          "Malignancy",
          "lung",
          "cancer",
          "mass",
          "oncology",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "thoracic"
      ]
  },
  {
      "name": "Breast Cancer (Pathological) TNM Staging",
      "id": "calculator_594",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Surgery"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "oncology",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "metastasis",
          "metastases",
          "neoplasm",
          "breast",
          "breast cancer",
          "mammogram",
          "tumour",
          "tumor"
      ]
  },
  {
      "name": "Edmonton Frail Scale",
      "id": "calculator_595",
      "description": "Simple tool to assess frailty in older patients",
      "categories": [
          "Geriatrics"
      ],
      "tags": [
          "geriatrics",
          "frailty"
      ]
  },
  {
      "name": "Shock Index",
      "id": "calculator_599",
      "description": "A more sensitive quotient for circulatory shock than vital signs alone",
      "categories": [
          "Emergency"
      ],
      "tags": [
          "hemorrhage",
          "trauma",
          "shock",
          "resuscitation",
          "vital signs"
      ]
  },
  {
      "name": "Abnormal Involuntary Movement Scale (AIMS)",
      "id": "calculator_601",
      "description": "12-item scale to assess severity of dyskinesias",
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery",
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Risk of Occupational Asthma due to High-Molecular Weight Agents",
      "id": "calculator_602",
      "description": "Estimate the likelihood of occupational asthma in subjects exposed to high-molecular weight agents",
      "categories": [
          "Respirology"
      ],
      "tags": [
          "asthma",
          "Diagnostic",
          "occupational",
          "HMW"
      ]
  },
  {
      "name": "Pittsburgh Sleep Quality Index (PSQI)",
      "id": "calculator_603",
      "description": "Measure your patient's sleep quality",
      "categories": [
          "Respirology"
      ],
      "tags": []
  },
  {
      "name": "Lip and Oral Cavity Cancer (Clinical) TNM Staging",
      "id": "calculator_605",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "lip",
          "h&n",
          "mouth",
          "gum",
          "tongue"
      ]
  },
  {
      "name": "Lip and Oral Cavity Cancer TNM Staging (Pathological)",
      "id": "calculator_606",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "lip",
          "h&n",
          "mouth",
          "gum",
          "tongue"
      ]
  },
  {
      "name": "Major Salivary Gland Cancer (Clinical)",
      "id": "calculator_607",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "Major Salivary Gland Cancer TNM Staging (Pathological)",
      "id": "calculator_608",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "CMML CPSS-Mol",
      "id": "calculator_609",
      "description": "Estimate risk of progression to AML in those with CMML using molecular genetics data",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": []
  },
  {
      "name": "International Prognostic Scoring System for Waldenstrom Macroglobulinemia",
      "id": "calculator_610",
      "description": "Estimate prognosis with the IPPSWM",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "WM"
      ]
  },
  {
      "name": "R₂eD AVM Hemorrhage Risk",
      "id": "calculator_619",
      "description": "Estimate risk of hemorrhage in patients with cerebral arteriovenous malformations",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "Nasopharyngeal Cancer TNM Staging",
      "id": "calculator_620",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Nasopharyngeal",
          "nasal",
          "Oral",
          "pharynx",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "nasopharynx"
      ]
  },
  {
      "name": "Clinical outcomes in CKD with severely decreased GFR",
      "id": "calculator_621",
      "description": "Estimate likelihood of clinical outcomes and their timing in people with severely decreased GFR.",
      "categories": [
          "Nephrology"
      ],
      "tags": []
  },
  {
      "name": "ESRD Risk Tool for Kidney Donor Candidates",
      "id": "calculator_622",
      "description": "15-year and lifetime risk for kidney donors\r\n\r\n",
      "categories": [
          "Nephrology",
          "Transplant"
      ],
      "tags": [
          "kidney",
          "ESRD",
          "donor",
          "Kidney Donor"
      ]
  },
  {
      "name": "HPV-Mediated (p16+) Oropharyngeal Cancer (Clinical)",
      "id": "calculator_623",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "HPV-Mediated (p16+) Oropharyngeal Cancer (Pathological)",
      "id": "calculator_624",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Attia Criteria for Evaluation of Pharyngitis",
      "id": "calculator_639",
      "description": "Estimate likelihood of Streptococcal pharyngitis as the etiology for sore throat",
      "categories": [
          "Emergency",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "pediatrics",
          "pharyngitis",
          "attia criteria"
      ]
  },
  {
      "name": "Acute Gout Diagnosis Rule",
      "id": "calculator_640",
      "description": "Clinical decision tool to assist in the diagnosis of acute gout",
      "categories": [
          "Emergency",
          "Rheumatology"
      ],
      "tags": [
          "gout",
          "inflammation"
      ]
  },
  {
      "name": "Absolute Neutrophil Count (ANC)",
      "id": "calculator_641",
      "description": "Determine ANC to assess risk of opportunistic infection",
      "categories": [
          "Infectious Disease",
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "infection",
          "neutrophil",
          "immunosuppressed"
      ]
  },
  {
      "name": "CSF WBC Correction In Blood Contaminated CSF",
      "id": "calculator_642",
      "description": "Correction equation for white cell count in setting of traumatic lumbar puncture",
      "categories": [
          "Infectious Disease"
      ],
      "tags": [
          "neutrophil",
          "cerebrospinal fluid",
          "lumbar puncture"
      ]
  },
  {
      "name": "Sodium Correction Rate for Hyponatremia",
      "id": "calculator_643",
      "description": "Rate of fluid administration in correction of hyponatremia",
      "categories": [
          "Emergency",
          "Nephrology"
      ],
      "tags": [
          "Sodium",
          "hyponatremia",
          "electrolytes"
      ]
  },
  {
      "name": "IV Drip Rate Calculator",
      "id": "calculator_644",
      "description": "Assistance in calculating accurate rates of medication administration",
      "categories": [
          "Emergency"
      ],
      "tags": [
          "medication",
          "IV fluids",
          "medication calculators"
      ]
  },
  {
      "name": "Estimated Blood Volume ",
      "id": "calculator_648",
      "description": "Blood volume estimate based on patient weight and demographics",
      "categories": [
          "Hematology"
      ],
      "tags": [
          "blood volume",
          "hematocrit"
      ]
  },
  {
      "name": "DIC Score",
      "id": "calculator_649",
      "description": "Assess likelihood of disseminated intravascular coagulation (DIC)",
      "categories": [
          "Hematology"
      ],
      "tags": [
          "hematology",
          "DIC",
          "Disseminated intravascular coagulation"
      ]
  },
  {
      "name": "Sodium Deficit in Hyponatremia",
      "id": "calculator_652",
      "description": "Amount of required sodium replenishment for the patient with hyponatremia",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "nephrology",
          "Sodium",
          "electrolytes",
          "internal medicine"
      ]
  },
  {
      "name": "CDC Height for Age Percentiles for Boys (2 - 20 years)",
      "id": "calculator_653",
      "description": "Calculate Z-score and percentile",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "pediatrics",
          "peds",
          "curve",
          "Age",
          "stature",
          "growth",
          "cdc",
          "height",
          "percentile",
          "z-score",
          "boys",
          "girls"
      ]
  },
  {
      "name": "Predicted Heart Mass Calculator (PHM)",
      "id": "calculator_654",
      "description": "Estimate donor/recipient heart mass for optimal cardiac transplant sizing ",
      "categories": [
          "Cardiac Surgery",
          "Transplant"
      ],
      "tags": []
  },
  {
      "name": "CDC Height for Age Percentiles for Girls (2 - 20 years)",
      "id": "calculator_655",
      "description": "Calculate Z-score and percentile",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "pediatrics",
          "peds",
          "curve",
          "Age",
          "stature",
          "growth",
          "cdc",
          "height",
          "percentile",
          "z-score",
          "boys",
          "girls"
      ]
  },
  {
      "name": "CDC Weight for Age Percentiles for Boys (2-20 years)",
      "id": "calculator_658",
      "description": "Calculate Z-score and percentile",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "pediatrics",
          "peds",
          "curve",
          "Age",
          "stature",
          "growth",
          "cdc",
          "height",
          "percentile",
          "z-score",
          "boys",
          "girls"
      ]
  },
  {
      "name": "CDC Weight for Age Percentiles for Girls (2 - 20 years)",
      "id": "calculator_659",
      "description": "Calculate Z-score and percentile",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "pediatrics",
          "peds",
          "curve",
          "Age",
          "stature",
          "growth",
          "cdc",
          "height",
          "percentile",
          "z-score",
          "boys",
          "girls"
      ]
  },
  {
      "name": "CDC Weight for Height Percentiles for Girls (77-121 cm tall)",
      "id": "calculator_660",
      "description": "Calculate Z-score and percentile",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "pediatrics",
          "peds",
          "curve",
          "Age",
          "stature",
          "growth",
          "cdc",
          "height",
          "percentile",
          "z-score",
          "boys",
          "girls"
      ]
  },
  {
      "name": "CDC/NCHS Infant Weight for Age Percentiles (&lt;36 months)",
      "id": "calculator_661",
      "description": "Calculate Z-score and percentile",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "pediatrics",
          "peds",
          "curve",
          "Age",
          "stature",
          "growth",
          "cdc",
          "height",
          "percentile",
          "z-score",
          "boys",
          "girls"
      ]
  },
  {
      "name": "ASPECTS: Alberta Stroke Programme Early CT Score for Predicting Outcome of Hyperacute Stroke",
      "id": "calculator_668",
      "description": "Predict outcome and risk of hemorrhage in acute ischemic stroke patients eligible for IV thrombolysis",
      "categories": [
          "Neurology / Neurosurgery",
          "Medical Imaging"
      ],
      "tags": []
  },
  {
      "name": "CDC Weight for Height Percentiles for Boys (77-121 cm tall)",
      "id": "calculator_669",
      "description": "Calculate Z-score and percentile",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "pediatrics",
          "peds",
          "curve",
          "Age",
          "stature",
          "growth",
          "cdc",
          "height",
          "percentile",
          "z-score",
          "boys",
          "girls"
      ]
  },
  {
      "name": "CDC/NCHS Infant Length for Age Percentiles (&lt;36 months)",
      "id": "calculator_671",
      "description": "Calculate Z-score and percentile",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "pediatrics",
          "peds",
          "curve",
          "weight",
          "Age",
          "stature",
          "growth",
          "cdc",
          "height",
          "percentile",
          "z-score",
          "boys",
          "girls",
          "infant"
      ]
  },
  {
      "name": "CDC/NCHS Infant Weight for Length Percentiles (&lt; 36 months)",
      "id": "calculator_672",
      "description": "Calculate Z-score and percentile",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "pediatrics",
          "Length",
          "peds",
          "curve",
          "weight",
          "Age",
          "stature",
          "growth",
          "cdc",
          "height",
          "percentile",
          "z-score",
          "boys",
          "girls",
          "infant"
      ]
  },
  {
      "name": "CDC/NCHS Infant Head Circumference for Age Percentiles (&lt;36 months)",
      "id": "calculator_673",
      "description": "Calculate Z-score and percentile",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "pediatrics",
          "Head",
          "peds",
          "curve",
          "Age",
          "stature",
          "growth",
          "cdc",
          "height",
          "percentile",
          "z-score",
          "boys",
          "girls",
          "circumference",
          "baby",
          "infant",
          "microcephaly",
          "macrocephaly"
      ]
  },
  {
      "name": "Newborn Hyperbilirubinemia Assessment",
      "id": "calculator_674",
      "description": "Predict risk of newborn (GA >35 weeks) developing hyperbilirubinemia and determine follow-up recommendations",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "Risk",
          "pediatric",
          "neonate",
          "newborn",
          "nomogram",
          "Bilirubin",
          "baby",
          "infant",
          "bhutani",
          "normogram",
          "phototherapy",
          "hyperbili",
          "neonatal",
          "bili",
          "tsb",
          "jaundice",
          "kernicterus",
          "abe",
          "cbe",
          "neurotox",
          "preterm",
          "abo",
          "dat",
          "g6pd",
          "cephalahematoma",
          "photo",
          "csp",
          "bilitool",
          "ped",
          "gestation"
      ]
  },
  {
      "name": "Diabetes Risk Score (Type 2)",
      "id": "calculator_675",
      "description": "Calculate risk of developing T2DM",
      "categories": [
          "Endocrinology"
      ],
      "tags": [
          "Risk",
          "Score",
          "diabetes",
          "dm2",
          "hyperglycemia",
          "t2d",
          "t2dm",
          "mellitus",
          "type 2"
      ]
  },
  {
      "name": "Revised Geneva clinical prediction rule for pulmonary embolism",
      "id": "calculator_676",
      "description": "Determine pre-test probability for pulmonary embolism",
      "categories": [
          "Emergency",
          "Respirology",
          "Hematology"
      ],
      "tags": []
  },
  {
      "name": "Mood Disorder Questionnaire (MDQ)",
      "id": "calculator_677",
      "description": "15 question self-report to screen for bipolar disorder",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Prognosis Calculator for Relapsed/Refractory DLBCL",
      "id": "calculator_682",
      "description": "Estimate survival in relapsed/refractory DLBCL",
      "categories": [
          "Hematology"
      ],
      "tags": [
          "prognosis",
          "DLBCL",
          "lymphoma",
          "refractory",
          "relapsed"
      ]
  },
  {
      "name": "BUN:Creatinine Ratio (BCR)",
      "id": "calculator_683",
      "description": "Determines the probable cause of acute renal failure",
      "categories": [
          "Nephrology"
      ],
      "tags": []
  },
  {
      "name": "Post Traumatic Stress Disorder (PCL-5)",
      "id": "calculator_684",
      "description": "20 questions that assesses the DSM-5 symptoms of PTSD",
      "categories": [
          "Mental Health"
      ],
      "tags": [
          "PTSD"
      ]
  },
  {
      "name": "GARFIELD-AF Risk Calculator",
      "id": "calculator_685",
      "description": "Compare the effects of different anticoagulant treatment decisions in atrial fibrillation ",
      "categories": [
          "Cardiology"
      ],
      "tags": []
  },
  {
      "name": "Burch-Wartofsky Point Scale (BWPS) for Thyrotoxicosis",
      "id": "calculator_688",
      "description": "Determine the likelihood of thyroid storm",
      "categories": [
          "Endocrinology"
      ],
      "tags": []
  },
  {
      "name": "FAINT Score in Syncope ",
      "id": "calculator_691",
      "description": "Identify low-risk patients 60 years or older presenting with syncope",
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "Syncope",
          "FAINT",
          "cardiac risk"
      ]
  },
  {
      "name": "Body Surface Area Based Dosing ",
      "id": "calculator_692",
      "description": "Medication dose adjustment based on body surface area (BSA) ",
      "categories": [
          "Nephrology",
          "General Calculators",
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "dosing",
          "bsa",
          "dose",
          "Medications",
          "body surface area",
          "dosage"
      ]
  },
  {
      "name": "Infrainguinal revascularization (open or PVI) for CLTI: 30 day and 2 year survival",
      "id": "calculator_693",
      "description": "Estimate survival after infrainguinal revascularization",
      "categories": [
          "Cardiology",
          "Vascular Surgery"
      ],
      "tags": []
  },
  {
      "name": "Emergency Department Detection of Chest Pain Score (EDACS)",
      "id": "calculator_695",
      "description": "Identifies chest pain patients at low-risk for major adverse cardiac events",
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "ACS",
          "Cardiac",
          "Acute coronary syndrome",
          "chest pain"
      ]
  },
  {
      "name": "MDS Specific Frailty Scale",
      "id": "calculator_696",
      "description": "Improve prognostication with this frailty scale specific to those patients with myelodysplastic syndrome.",
      "categories": [
          "Cardiology",
          "Hematology"
      ],
      "tags": []
  },
  {
      "name": "Pregnancy Gestation by LMP and Ultrasound Biometry",
      "id": "calculator_697",
      "description": "Predicts estimated delivery dates and gestational age using LMP and biometry",
      "categories": [
          "Obstetrics & Gynecology",
          "Anesthesiology"
      ],
      "tags": []
  },
  {
      "name": "Osteoporosis Self-Assessment Tool for Men ",
      "id": "calculator_698",
      "description": "Risk stratify men for likelihood of osteoporosis",
      "categories": [
          "Endocrinology",
          "Geriatrics"
      ],
      "tags": [
          "fracture",
          "orthopedics",
          "osteoporosis",
          "bones"
      ]
  },
  {
      "name": "2HELPS2B Score",
      "id": "calculator_700",
      "description": "Estimate duration of EEG monitoring needed to detect 95% of seizures",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "Pack Years in Smoking",
      "id": "calculator_701",
      "description": "Quantifies patient smoking habits into a standardized form",
      "categories": [
          "Respirology"
      ],
      "tags": [
          "respirology",
          "COPD",
          "Smoking",
          "Lung cancer"
      ]
  },
  {
      "name": "Testicular Workup for Ischemia and Suspected Torsion (TWIST) score",
      "id": "calculator_702",
      "description": "Estimate probability of torsion in acute testicular pain ",
      "categories": [
          "Emergency",
          "Urology",
          "Pediatrics"
      ],
      "tags": [
          "urology",
          "pediatrics",
          "Testicular pain",
          "scrotum",
          "torsion"
      ]
  },
  {
      "name": "Troponin-only Manchester Acute Coronary Syndromes (TMACS) Decision Aid",
      "id": "calculator_703",
      "description": "Identify chest pain patients at low-risk for major adverse cardiac events",
      "categories": [
          "Cardiology",
          "Emergency"
      ],
      "tags": [
          "MI",
          "ACS",
          "Cardiac",
          "Acute coronary syndrome",
          "chest pain",
          "TMACS"
      ]
  },
  {
      "name": "Predicting Ionized Hypocalcemia in Critical Care",
      "id": "calculator_704",
      "description": "In critical care patients, estimate the single most likely ionised calcium value--with its surrounding 95% range of likely values--as well as the chance the true value is under 1.10 mM. The reference range for arterial iCa is 1.15-1.29 mM.",
      "categories": [
          "Nephrology",
          "Endocrinology",
          "Critical Care"
      ],
      "tags": []
  },
  {
      "name": "Lean Body Weight (Female)",
      "id": "calculator_705",
      "description": "Calculates estimated patient fat-free body mass in females",
      "categories": [
          "General Calculators",
          "Oncology"
      ],
      "tags": [
          "Body mass",
          "pharmacology",
          "volume of distribution"
      ]
  },
  {
      "name": "Lean Body Weight (Male)",
      "id": "calculator_706",
      "description": "Calculates estimated patient fat-free body mass in males",
      "categories": [
          "General Calculators",
          "Oncology"
      ],
      "tags": [
          "Body mass",
          "pharmacology",
          "volume of distribution"
      ]
  },
  {
      "name": "Behcet’s Syndrome International Study Group Criteria",
      "id": "calculator_707",
      "description": "Diagnose Behcet’s disease",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "skin",
          "Behcet’s disease",
          "dermatology",
          "ulcerations"
      ]
  },
  {
      "name": "Osteoporosis Self-Assessment Tool for Women",
      "id": "calculator_708",
      "description": "Risk stratify women for likelihood of osteoporosis",
      "categories": [
          "Endocrinology",
          "Geriatrics"
      ],
      "tags": [
          "fracture",
          "orthopedics",
          "osteoporosis",
          "bones"
      ]
  },
  {
      "name": "TIA Prognosis: Risk of Stroke by 90 Days After Presentation",
      "id": "calculator_710",
      "description": "Risk stratify stroke risk within 90 days of TIA presentation",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "tia",
          "stroke",
          "neurology",
          "emergency medicine"
      ]
  },
  {
      "name": "H Score",
      "id": "calculator_712",
      "description": "Diagnose reactive hemophagocytic syndrome (HLH or MAS)",
      "categories": [
          "Hematology"
      ],
      "tags": [
          "hematology"
      ]
  },
  {
      "name": "International IgAN Prediction Tool at biopsy - Pediatrics",
      "id": "calculator_713",
      "description": "Determine prognosis in children in IgA nephropathy",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "iga",
          "igan"
      ]
  },
  {
      "name": "Adverse Childhood Experience (ACE)",
      "id": "calculator_715",
      "description": "10 question screener for numerous health, social, and behavioral problems.",
      "categories": [
          "Preventive Medicine",
          "Mental Health",
          "Addiction Medicine"
      ],
      "tags": []
  },
  {
      "name": "Glasgow Outcome Scale Extended [GOS-E]",
      "id": "calculator_721",
      "description": "Stratifies patient’s functional outcome after acute brain injury",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "Glasgow Outcome Scale",
          "Traumatic Brain Injury",
          "Subarachnoid Hemorrhage"
      ]
  },
  {
      "name": "Plasmic Score for TTP",
      "id": "calculator_722",
      "description": "Predict ADAMTS13 deficiency in suspected thrombotic thrombocytopenic purpura (TTP) with high discrimination.",
      "categories": [
          "Hematology"
      ],
      "tags": [
          "ttp",
          "tma",
          "ADAMTS13",
          "MAHA"
      ]
  },
  {
      "name": "ROX Index to Predict Risk of Intubation",
      "id": "calculator_724",
      "description": "Predict risk of intubation at 2, 6 and 12 hours in hypoxemic respiratory failure. Not yet validated for COVID-19",
      "categories": [
          "Respirology",
          "Critical Care",
          "COVID-19"
      ],
      "tags": [
          "ROX"
      ]
  },
  {
      "name": "Sexual Desire Inventory-2 (SDI-2)",
      "id": "calculator_727",
      "description": "14-item scale for sexual desire",
      "categories": [
          "Urology",
          "Obstetrics & Gynecology",
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "COVID-19 Prognostic Tool",
      "id": "calculator_731",
      "description": "Estimate mortality rates in patients with COVID-19. Adapted from CDC materials.",
      "categories": [
          "COVID-19"
      ],
      "tags": [
          "COVID",
          "COVID19",
          "COVID-19"
      ]
  },
  {
      "name": "Recruitment to Inflation Ratio",
      "id": "calculator_734",
      "description": "Characterize lung recruitability to personalize PEEP.  Adapted from an algorithm developed by The Toronto Centre of Excellence in Mechanical Ventilation (CoEMV).",
      "categories": [
          "Anesthesiology"
      ],
      "tags": []
  },
  {
      "name": "COVID-19 Ventilation Protocol",
      "id": "calculator_735",
      "description": "Adapted from an algorithm developed by The Toronto Centre of Excellence in Mechanical Ventilation (CoEMV)",
      "categories": [
          "Critical Care",
          "COVID-19"
      ],
      "tags": []
  },
  {
      "name": "Fracture Risk for Women with Known Bone Mineral Density (BMD) ",
      "id": "calculator_736",
      "description": "Estimate fracture risk for women given estimated bone health",
      "categories": [
          "Endocrinology",
          "Geriatrics"
      ],
      "tags": [
          "Osteoarthritis",
          "fracture risk",
          "bone mineral density"
      ]
  },
  {
      "name": "ProVent 14 Score for prolonged mechanical ventilation",
      "id": "calculator_739",
      "description": "Determine risk of 1-year mortality after prolonged mechanical ventilation",
      "categories": [
          "Respirology",
          "Critical Care"
      ],
      "tags": []
  },
  {
      "name": "Primary Care PTSD Screen for DSM-5 (PC-PTSD-5)",
      "id": "calculator_740",
      "description": "A five question screener for PTSD",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Hypopharyngeal Cancer (Clinical)",
      "id": "calculator_742",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Hypopharyngeal Cancer (Pathological)",
      "id": "calculator_743",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Maxillary Sinus Cancer (Clinical)",
      "id": "calculator_744",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Maxillary Sinus Cancer (Pathological)",
      "id": "calculator_745",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Nasal Cavity and Ethmoid Sinus Cancer (Pathological)",
      "id": "calculator_746",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Nasal Cavity and Ethmoid Sinus Cancer (Clinical)",
      "id": "calculator_747",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Laryngeal Cancer: Supraglottis (Pathological)",
      "id": "calculator_748",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Laryngeal Cancer: Supraglottis (Clinical)",
      "id": "calculator_749",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "COVID-19 Critical Illness Prediction Tool (COVID-GRAM)",
      "id": "calculator_750",
      "description": "Predict occurrence of ICU admission, mechanical ventilation, or death in hospitalized patients with COVID-19",
      "categories": [
          "COVID-19"
      ],
      "tags": []
  },
  {
      "name": "Neutrophil to Lymphocyte Ratio (NLR)",
      "id": "calculator_751",
      "description": null,
      "categories": [
          "Infectious Disease"
      ],
      "tags": []
  },
  {
      "name": "PEN-FAST - Penicillin Allergy Risk Tool",
      "id": "calculator_752",
      "description": "Clinical decision rule for point-of-care risk assessment of patient-reported penicillin allergies.",
      "categories": [
          "Emergency",
          "Urology",
          "Respirology",
          "Infectious Disease",
          "Pediatrics",
          "Cardiac Surgery",
          "Vascular Surgery",
          "Surgery",
          "Critical Care",
          "Anesthesiology",
          "Transplant"
      ],
      "tags": [
          "Penicillin",
          "Allergy",
          "Anaphylaxis",
          "SCAR",
          "PEN-FAST",
          "penfast"
      ]
  },
  {
      "name": "Adult ADHD Self-Report Scales (ASRS)",
      "id": "calculator_753",
      "description": "6 question scale to screen for adult ADHD",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "4AT (Rapid Clinical Test for Delirium)",
      "id": "calculator_754",
      "description": "A ultra-brief screener for delirium and cognitive impairment ",
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery",
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Elevated serum creatinine or hyperkalemia after ACEi/ARB",
      "id": "calculator_756",
      "description": "Estimate risk of elevated serum creatinine or hyperkalemia after ACEi or ARB initiation\r\n",
      "categories": [
          "Cardiology",
          "Nephrology"
      ],
      "tags": []
  },
  {
      "name": "ARISCAT Score",
      "id": "calculator_758",
      "description": "Risk calculator for postoperative pulmonary complications",
      "categories": [
          "Respirology",
          "Anesthesiology"
      ],
      "tags": [
          "Pulmonary",
          "Postoperative",
          "ARISCAT",
          "PPC"
      ]
  },
  {
      "name": "Oropharyngeal (p16-) Cancer TNM Staging (Pathological)",
      "id": "calculator_759",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Oropharyngeal (p16-) Cancer TNM Staging (Clinical)",
      "id": "calculator_760",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Laryngeal Cancer: Glottis (Clinical)",
      "id": "calculator_761",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Laryngeal Cancer: Glottis (Pathological)",
      "id": "calculator_762",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Laryngeal Cancer: Subglottis (Clinical)",
      "id": "calculator_763",
      "description": "cTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Laryngeal Cancer: Subglottis (Pathological)",
      "id": "calculator_764",
      "description": "pTNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Oropharyngeal",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "oropharynx",
          "hpv"
      ]
  },
  {
      "name": "Differentiated Thyroid Cancer TNM Staging",
      "id": "calculator_765",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Endocrinology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "Anaplastic Thyroid Cancer TNM Staging",
      "id": "calculator_766",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Endocrinology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "Medullary Thyroid Cancer TNM Staging",
      "id": "calculator_767",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Oncology",
          "Endocrinology",
          "Otolaryngology (ENT)"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "Colorectal Cancer",
      "id": "calculator_768",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Gastroenterology",
          "Oncology"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "Gastric Cancer TNM Staging",
      "id": "calculator_769",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Gastroenterology",
          "Oncology"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "Bush-Francis Catatonia Rating Scale (BFCRS)",
      "id": "calculator_770",
      "description": "23 questions to assess the severity of catatonia.",
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery",
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Cervical Cancer TNM Staging",
      "id": "calculator_771",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Obstetrics & Gynecology",
          "Oncology"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "Hepatocellular Carcinoma TNM Staging",
      "id": "calculator_772",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Gastroenterology",
          "Oncology"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": " Bladder Cancer TNM Staging",
      "id": "calculator_773",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Urology",
          "Oncology"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "Esophagus and Esophagogastric Junction Cancers (Squamous Cell Carcinoma)",
      "id": "calculator_774",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Gastroenterology",
          "Oncology"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "Esophagus and Esophagogastric Junction Cancers (Adenocarcinoma)",
      "id": "calculator_775",
      "description": "TNM Staging | AJCC 2017",
      "categories": [
          "Gastroenterology",
          "Oncology"
      ],
      "tags": [
          "Malignancy",
          "cancer",
          "mass",
          "oncology",
          "Head",
          "Carcinoma",
          "TNM",
          "staging",
          "Stage",
          "Oral",
          "Salivary",
          "Gland",
          "metastasis",
          "metastases",
          "neoplasm",
          "tumour",
          "tumor",
          "h&n",
          "mouth",
          "salivary gland"
      ]
  },
  {
      "name": "SWAP Score for Out of Hospital Cardiac Arrest",
      "id": "calculator_776",
      "description": "Predicts which patients with OHCA will have poor neurologic recovery",
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery",
          "Critical Care"
      ],
      "tags": [
          "SWAP",
          "out-of-hospital cardiac arrest",
          "CPR",
          "OHCA"
      ]
  },
  {
      "name": "sPESI | simplified Pulmonary Embolism Severity Index",
      "id": "calculator_777",
      "description": "Estimate risk of 30-day mortality in patients with acute PE",
      "categories": [
          "Emergency",
          "Respirology",
          "Hematology"
      ],
      "tags": [
          "death",
          "Pulmonary embolism",
          "risk score"
      ]
  },
  {
      "name": "Hestia Criteria for Outpatient Management of Pulmonary Embolism",
      "id": "calculator_778",
      "description": "Identify patients with acute PE who may be appropriate for outpatient management",
      "categories": [
          "Emergency",
          "Respirology",
          "Hematology"
      ],
      "tags": [
          "death",
          "Pulmonary embolism",
          "risk score",
          "Hestia"
      ]
  },
  {
      "name": "Newborn Hyperbilirubinemia Rate of Rise",
      "id": "calculator_781",
      "description": "Calculate rate of serum bilirubin rise to determine risk of severe hyperbilirubinemia",
      "categories": [
          "Pediatrics"
      ],
      "tags": [
          "rate",
          "Bilirubin",
          "baby",
          "infant",
          "hyperbili",
          "neonatal",
          "bili",
          "jaundice",
          "photo",
          "bilitool",
          "ped",
          "rise",
          "ror"
      ]
  },
  {
      "name": "VISION perioperative risk using NT-proBNP",
      "id": "calculator_783",
      "description": "Predict risk of MI, vascular death, and all-cause death in patients having non-cardiac surgery",
      "categories": [
          "Cardiology",
          "Urology",
          "Vascular Surgery",
          "Surgery",
          "Anesthesiology"
      ],
      "tags": []
  },
  {
      "name": "Sepsis Induced Coagulopathy (SIC) Score",
      "id": "calculator_784",
      "description": "Estimate risk of sepsis-induced coagulopathy ",
      "categories": [
          "Emergency",
          "Hematology",
          "Critical Care"
      ],
      "tags": [
          "mortality",
          "Bleeding",
          "SOFA",
          "sepsis",
          "DIC",
          "coagulopathy"
      ]
  },
  {
      "name": "Bacterial Meningitis Score for Children",
      "id": "calculator_785",
      "description": "Risk stratification tool for children with possible bacterial meningitis",
      "categories": [
          "Emergency",
          "Infectious Disease"
      ],
      "tags": [
          "pediatrics",
          "emergency medicine",
          "lumbar puncture",
          "meningitis"
      ]
  },
  {
      "name": "Duke Activity Status Index (DASI)",
      "id": "calculator_786",
      "description": "Patient-reported estimate of functional capacity, VO2 max and METs",
      "categories": [
          "Anesthesiology"
      ],
      "tags": [
          "capacity",
          "functional",
          "met",
          "DASI",
          "VO2"
      ]
  },
  {
      "name": "Guide Transplant Referral for Incident Dialysis Patients Over 70",
      "id": "calculator_787",
      "description": "Guide renal transplant referral with this mortality estimate for dialysis patients 70 years or older at dialysis start",
      "categories": [
          "Nephrology"
      ],
      "tags": []
  },
  {
      "name": "Severe Community Acquired Pneumonia (SCAP) Score",
      "id": "calculator_788",
      "description": "Risk prognostication for patients presenting with community acquired pneumonia.",
      "categories": [
          "Emergency",
          "Respirology"
      ],
      "tags": [
          "mortality",
          "Intensive Care",
          "Pneumonia",
          "risk stratification"
      ]
  },
  {
      "name": "Columbia-Suicide Severity Rating Scale (C-SSRS)",
      "id": "calculator_795",
      "description": "5-question suicide risk assessment. ",
      "categories": [
          "Emergency",
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "International prognostic score for asymptomatic early-stage CLL",
      "id": "calculator_804",
      "description": "Estimate likelihood of treatment requirement in patients with early-stage chronic lymphocytic leukemia",
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "CLL"
      ]
  },
  {
      "name": "Barnes Akathisia Rating Scale (BARS)",
      "id": "calculator_808",
      "description": "A four-item rating scale for drug-induced akathisia.",
      "categories": [
          "Neurology / Neurosurgery",
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "TEVAR Mortality Risk Calculator",
      "id": "calculator_809",
      "description": "Estimate peri-operative mortality risk for TEVAR (Thoracic endovascular aortic repair)",
      "categories": [
          "Cardiology",
          "Vascular Surgery",
          "Anesthesiology"
      ],
      "tags": []
  },
  {
      "name": "Spinal Instability Neoplastic Score (SINS)",
      "id": "calculator_810",
      "description": "Determine instability risk in patients with spinal neoplasia",
      "categories": [
          "Oncology",
          "Orthopedics",
          "Medical Imaging"
      ],
      "tags": []
  },
  {
      "name": "ECABG score",
      "id": "calculator_811",
      "description": "Predict emergency coronary artery bypass graft surgery after elective percutaneous coronary intervention",
      "categories": [
          "Cardiology",
          "Critical Care"
      ],
      "tags": []
  },
  {
      "name": "Canadian TIA Score",
      "id": "calculator_815",
      "description": "Estimate 7-day Risk of  Stroke or Carotid Revascularization",
      "categories": [
          "Emergency",
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "ABCD2",
          "tia",
          "stroke",
          "ABCD",
          "transient"
      ]
  },
  {
      "name": "Severe COVID-19 Prediction Tool",
      "id": "calculator_816",
      "description": "Predict risk of severe disease or mortality in COVID-19",
      "categories": [
          "Infectious Disease",
          "COVID-19"
      ],
      "tags": []
  },
  {
      "name": "MADIT-ICD Benefit Score",
      "id": "calculator_817",
      "description": "Predicted Benefit of an Implantable Cardioverter-Defibrillator for primary prevention ",
      "categories": [
          "Cardiology"
      ],
      "tags": []
  },
  {
      "name": "Penn Alcohol Craving Scale (PACS)",
      "id": "calculator_818",
      "description": "The Penn Alcohol Craving Scale (PACS) is a 5-item questionnaire that measures an individual’s craving to drink alcohol in the past week.",
      "categories": [
          "Emergency",
          "Mental Health",
          "Addiction Medicine"
      ],
      "tags": []
  },
  {
      "name": "Insomnia Severity Index (ISI)",
      "id": "calculator_820",
      "description": "Assess the nature, severity, and impact of insomnia and monitor treatment response in adults",
      "categories": [
          "Respirology",
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Canadian Clinical Practice Guidelines for Acute Aortic Syndrome (RIPP score)",
      "id": "calculator_821",
      "description": "Pre test probability decision aid for the diagnosis of acute aortic syndrome",
      "categories": [
          "Emergency"
      ],
      "tags": []
  },
  {
      "name": "CKiD U25 eGFR calculator",
      "id": "calculator_822",
      "description": "Estimate GFR in children, adolescents and young adults less than 25 years old",
      "categories": [
          "Nephrology",
          "Pediatrics"
      ],
      "tags": []
  },
  {
      "name": "Woo Perioperative Risk",
      "id": "calculator_823",
      "description": "Risk estimation of stroke, cardiac and mortality risk after non‐cardiac surgery",
      "categories": [
          "Cardiology",
          "Neurology / Neurosurgery",
          "Anesthesiology"
      ],
      "tags": [
          "stroke",
          "Cardiac",
          "gupta",
          "perioperative",
          "woo",
          "periop"
      ]
  },
  {
      "name": "Morningness-Eveningness Questionnaire (MEQ)",
      "id": "calculator_829",
      "description": "Assess morningness and eveningness. Questions are framed in a preferential manner, where the respondent is asked to indicate when, for example, he/she would prefer to wake up or start sleep, rather than when he/she actually does.",
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Risk of choledocholithiasis in patients with symptomatic cholelithiasis",
      "id": "calculator_833",
      "description": "A proposed strategy to assign risk of choledocholithiasis in patients with symptomatic cholelithiasis based on clinical predictors based on the ASGE Guidelines",
      "categories": [
          "Gastroenterology"
      ],
      "tags": []
  },
  {
      "name": "AKI risk after surgery (Postop-MAKE by Woo)",
      "id": "calculator_834",
      "description": "Calculate AKI risk after surgery",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "Surgery",
          "AKI",
          "preoperative risk assessment"
      ]
  },
  {
      "name": "Drug Abuse Screen Test (DAST-10)",
      "id": "calculator_835",
      "description": "DAST-10 drug abuse screener with clinical interventions",
      "categories": [
          "Mental Health",
          "Addiction Medicine"
      ],
      "tags": []
  },
  {
      "name": "SAVE (Survival after Veno-Arterial ECMO) Score",
      "id": "calculator_837",
      "description": "Prognostic score for survival after VA ECMO for refractory cardiogenic shock",
      "categories": [
          "Cardiology",
          "Respirology",
          "Critical Care"
      ],
      "tags": [
          "cardiac arrest",
          ", extracorporeal membrane",
          "oxygenation",
          "alveolar ventilation function",
          "cardiogenic shock",
          "congenital heart disease",
          "cell respiration"
      ]
  },
  {
      "name": "Obstetric Comorbidity Index",
      "id": "calculator_838",
      "description": "Determines the risk of severity of maternal morbidity.",
      "categories": [
          "Obstetrics & Gynecology"
      ],
      "tags": [
          "delivery",
          "labor",
          "pregnancy",
          "hemorrhage",
          "maternal death",
          "risk assessment",
          "screening",
          "severe maternal morbidity",
          "postpartum"
      ]
  },
  {
      "name": "International IgAN Prediction Tool post-biopsy - Adults",
      "id": "calculator_839",
      "description": "Determine prognosis in adults with IgA nephropathy",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "iga",
          "igan"
      ]
  },
  {
      "name": "OS Probability Following CRC Surgery",
      "id": "calculator_840",
      "description": "Prognostic score for overall survival following Colorectal Cancer surgery",
      "categories": [
          "Oncology"
      ],
      "tags": [
          "Surgery",
          "TNM",
          "Colorectal Cancer"
      ]
  },
  {
      "name": "Pharmacotherapy for Type 2 Diabetes (2020 update to the Diabetes Canada guidelines)",
      "id": "calculator_841",
      "description": "Recommends medications for type 2 diabetes management based on patient characteristics.",
      "categories": [
          "Respirology"
      ],
      "tags": [
          "diabetes canada",
          "pharmacotherapy",
          "Type 2 diabetes",
          "antihyperglycemic agents"
      ]
  },
  {
      "name": "Clinician-Rated Dimensions of Psychosis Symptom Severity (CRDPSS)",
      "id": "calculator_843",
      "description": "The Clinician-Rated Dimensions of Psychosis Symptom Severity (CRDPSS) scale assess the dimensional aspects of psychosis in daily clinical practice.",
      "categories": [
          "Mental Health"
      ],
      "tags": [
          "schizophrenia"
      ]
  },
  {
      "name": "MSA Criteria",
      "id": "calculator_845",
      "description": "Diagnostic criteria for clinically established and clinically probable MSA.",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "MSA",
          "Multiple System Atrophy"
      ]
  },
  {
      "name": "Mifflin-St Jeor Equation",
      "id": "calculator_846",
      "description": "Tool to predict daily energy expenditure in healthy adults.",
      "categories": [
          "Gastroenterology"
      ],
      "tags": [
          "Resting metabolic rate",
          "RMR",
          "energy expenditure",
          "weight loss",
          "caloric needs"
      ]
  },
  {
      "name": "IMWG risk model for smoldering multiple myeloma (SMM)",
      "id": "calculator_847",
      "description": "This risk score accounts for the entire range of the variables in the 2/20/20 model, which can be used to provide a more individualized 2-year risk of progression for every SMM patient.",
      "categories": [
          "Hematology"
      ],
      "tags": []
  },
  {
      "name": "RESP score for VV ECMO survival",
      "id": "calculator_848",
      "description": "Tool to predict survival in patients receiving Venovenous (VV) Extracorporeal Membrane Oxygenation (ECMO)",
      "categories": [
          "Respirology"
      ],
      "tags": [
          "ARDS",
          "Extracorporeal membrane oxygenation",
          "ECMO",
          "acute respiratory distress syndrome",
          "respiratory failure"
      ]
  },
  {
      "name": "Ischemia Risk Score",
      "id": "calculator_849",
      "description": "Determine a patients likelihood of having ischemia on SPECT MPI\r\nTool to determine myocardial ischemia risk",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "CAD",
          "ischemia",
          "myocardial ischemia",
          "coronary artery disease",
          "myocardial perfusion imaging",
          "SPECT MPI"
      ]
  },
  {
      "name": "Madras Head Injury Prognostic Scale",
      "id": "calculator_851",
      "description": "To predict the outcome in a patient with traumatic brain injury",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": [
          "trauma",
          "brain injury"
      ]
  },
  {
      "name": "Early Cardiovascular Health Risk Score",
      "id": "calculator_853",
      "description": "Determine overall cardiovascular health in the present time.",
      "categories": [
          "Cardiology"
      ],
      "tags": []
  },
  {
      "name": "Barratt Impulsiveness Scale (BIS-11)",
      "id": "calculator_854",
      "description": null,
      "categories": [
          "Mental Health"
      ],
      "tags": [
          "Self-Control",
          "attention",
          "impulsiveness",
          "reactive",
          "thoughtfulness",
          "emotional",
          "erratic",
          "inconsistent"
      ]
  },
  {
      "name": "Prodromal Questionnaire (PQ-16)",
      "id": "calculator_855",
      "description": null,
      "categories": [
          "General Calculators"
      ],
      "tags": []
  },
  {
      "name": "Frequency, Intensity and Burden of Side Effects Rating Scale (FIBSER) Revised",
      "id": "calculator_858",
      "description": null,
      "categories": [
          "Mental Health"
      ],
      "tags": []
  },
  {
      "name": "Sick, Control, One, Fat, Food (SCOFF)",
      "id": "calculator_859",
      "description": null,
      "categories": [
          "General Calculators"
      ],
      "tags": [
          "Screening Questionnaire for Eating Disorders"
      ]
  },
  {
      "name": "Weight-based medication dosing",
      "id": "calculator_862",
      "description": "Adjust medication dose based on patient weight.",
      "categories": [
          "General Calculators"
      ],
      "tags": [
          "weight",
          "medication",
          "weight-based",
          "calculation"
      ]
  },
  {
      "name": "eGFR using CKD-EPI (Creatinine-Cystatin C) Equation (2021)",
      "id": "calculator_863",
      "description": "Calculate eGFR using the CKD-EPI (Creatinine-Cystatin C) Equation (2021)",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "chronic kidney disease",
          "Serum Creatinine",
          "eGFR estimated Glomerular filtration rate",
          "Serum Cystatin C"
      ]
  },
  {
      "name": "Blood volume estimation in obesity",
      "id": "calculator_864",
      "description": "As BMI increases the relationship between 70 mL/kg and estimated blood volume loses accuracy. This tool will help account for the decreased perfusion of adipose tissue.",
      "categories": [
          "Anesthesiology"
      ],
      "tags": []
  },
  {
      "name": "FLIPI24",
      "id": "calculator_865",
      "description": "FLIPI24: An Improved International Prognostic Model Developed on Early Events in Follicular Lymphoma.",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "The Mood and Feelings Questionnaire (MFQ) - Child Long Version",
      "id": "calculator_866",
      "description": null,
      "categories": [
          "Mental Health"
      ],
      "tags": [
          "depression",
          "Adolescence"
      ]
  },
  {
      "name": "The Mood and Feelings Questionnaire (MFQ) - Parent Long Version",
      "id": "calculator_867",
      "description": null,
      "categories": [
          "Mental Health"
      ],
      "tags": [
          "depression",
          "Adolescence"
      ]
  },
  {
      "name": "Estimated 2-year PFS2 with 2L BTKi in R/R MCL",
      "id": "calculator_868",
      "description": "Estimated 2-year PFS2 with 2L BTKi in Relapsed/Refractory Mantle Cell Lymphoma.",
      "categories": [
          "Hematology"
      ],
      "tags": []
  },
  {
      "name": "A-HIPI",
      "id": "calculator_869",
      "description": null,
      "categories": [
          "Hematology",
          "Oncology"
      ],
      "tags": [
          "hematology",
          "oncology",
          "lymphoma",
          "internal medicine",
          "Adolescent and young adults (AYA)"
      ]
  },
  {
      "name": "Therapy-Disability-Neurology Grade",
      "id": "calculator_870",
      "description": "Determine severity of peri-operative complications in neurosurgery.",
      "categories": [
          "Neurology / Neurosurgery"
      ],
      "tags": []
  },
  {
      "name": "Transplant Conditioning Intensity (TCI) score",
      "id": "calculator_871",
      "description": "Determine the intensity of conditioning regimen given before allogeneic hematopoietic cell transplantation (allo-HCT).",
      "categories": [
          "Hematology"
      ],
      "tags": []
  },
  {
      "name": "eGFR using Updated MDRD Equation (2006)",
      "id": "calculator_872",
      "description": "Calculate eGFR using the updated MDRD (4 Variables, and Standardized creatinine) Equation (2006)",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "chronic kidney disease",
          "Serum Creatinine",
          "eGFR estimated Glomerular filtration rate",
          "Modification of Diet in Renal Disease (MDRD)"
      ]
  },
  {
      "name": "KIDNEY RECOVERY AND DEATH IN OUTPATIENTS RISK GROUP (ReDO Risk group)",
      "id": "calculator_874",
      "description": "The ReDO risk group is generated to determine accurate expected probabilities of recovery to dialysis-independence (accounting for the competing risk of death) and death within one year in patients who continued outpatient dialysis after initiating dialysis in hospital.",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "chronic kidney disease",
          "Serum Creatinine",
          "Charlson score",
          "Albumin to creatinine ratio eGFR estimated Glomerular filtration"
      ]
  },
  {
      "name": "The BLISTER Score for CIED infection",
      "id": "calculator_876",
      "description": "Estimates the risk of CIED infection within 12 months of a procedure, and provides a threshold for which patients should be allocated an antimicrobial envelope.",
      "categories": [
          "Cardiology"
      ],
      "tags": []
  },
  {
      "name": "Mentzer Index",
      "id": "calculator_878",
      "description": "Differentiating iron deficiency anemia from beta thalassemia.",
      "categories": [
          "Hematology"
      ],
      "tags": []
  },
  {
      "name": "Charlson comorbidity Index score (CCI Score)",
      "id": "calculator_879",
      "description": "To determine Charlson comorbidity Index score and estimate 10 years survival rate in patients with multiple comorbidities.",
      "categories": [
          "General Calculators"
      ],
      "tags": [
          "myocardial infarction",
          "dementia",
          "Congestive heart failure",
          "peripheral vascular disease",
          "peptic ulcer disease"
      ]
  },
  {
      "name": "New England Spinal Metastatic Score (NESMS)",
      "id": "calculator_882",
      "description": "Prognostication of mortality in patients with spinal metastases.",
      "categories": [
          "Orthopedics"
      ],
      "tags": []
  },
  {
      "name": "EGRIS workflow",
      "id": "calculator_883",
      "description": null,
      "categories": [
          "Respirology"
      ],
      "tags": []
  },
  {
      "name": "Free Water Deficit",
      "id": "calculator_884",
      "description": "The Free Water Deficit in Hypernatremia is calculated using %Total body water fraction.",
      "categories": [
          "Nephrology"
      ],
      "tags": []
  },
  {
      "name": "REVISED FIBROMYALGIA IMPACT QUESTIONNAIRE (FIQR)",
      "id": "calculator_885",
      "description": "The Revised FIBROMYALGIA IMPACT QUESTIONNAIRE (FIQR) is revised form of the Fibromyalgia Impact Questionnaire (FIQ), which is a commonly used questionnaire for the evaluation of fibromyalgia (FM) patients and it has 21 questions.",
      "categories": [
          "Rheumatology"
      ],
      "tags": [
          "rheumatology"
      ]
  },
  {
      "name": "Primary Hyperoxaluria Prediction Tool",
      "id": "calculator_886",
      "description": "Predicts the probability of primary hyperoxaluria in adult patients undergoing chronic hemodialysis",
      "categories": [
          "Nephrology",
          "Urology"
      ],
      "tags": []
  },
  {
      "name": "Maternal blood volume estimator",
      "id": "calculator_887",
      "description": "A simple calculator to more accurately estimate maternal blood volume after 34 weeks gestation",
      "categories": [
          "Anesthesiology"
      ],
      "tags": []
  },
  {
      "name": "DENOVA score",
      "id": "calculator_889",
      "description": "Determine need for echocardiographic investigation for infectious endocarditis in\r\npatients with monomicrobial Enterococcus faecalis bacteremia.",
      "categories": [
          "Infectious Disease"
      ],
      "tags": []
  },
  {
      "name": "International IgAN Prediction Tool post-biopsy – Pediatric",
      "id": "calculator_890",
      "description": "Determine prognosis in children with IgA nephropathy",
      "categories": [
          "Nephrology"
      ],
      "tags": [
          "iga",
          "igan"
      ]
  },
  {
      "name": "Normal CKiD U25 Serum Creatinine",
      "id": "calculator_891",
      "description": "Can be used to calculate a normal serum creatinine for a patient based upon their height and age",
      "categories": [
          "Pediatrics"
      ],
      "tags": []
  },
  {
      "name": "Cardiac output - Fick method",
      "id": "calculator_892",
      "description": "To Calculate cardiac output, cardiac index, stroke volume and stroke volume index.",
      "categories": [
          "Cardiology"
      ],
      "tags": [
          "Cardiac output",
          "Cardiac index",
          "Stroke volume",
          "Stroke volume index"
      ]
  }
];

// Enhanced search function that supports searching in name, description, categories and tags
export const searchCalculatorsMultilingual = (query) => {
  if (!query || query.length < 3) return [];
  const lowerQuery = query.toLowerCase();
  
  return calculators.filter(calc => {
    // Search in name
    if (calc.name.toLowerCase().includes(lowerQuery)) {
      return true;
    }
    
    // Search in description
    if (calc.description?.toLowerCase().includes(lowerQuery)) {
      return true;
    }
    
    // Search in categories
    if (calc.categories?.some(category => category.toLowerCase().includes(lowerQuery))) {
      return true;
    }
    
    // Search in tags
    if (calc.tags?.some(tag => tag.toLowerCase().includes(lowerQuery))) {
      return true;
    }
    
    return false;
  });
};

// URL to view all calculators
export const allCalculatorsUrl = "https://qxmd.com/calculate";

export default calculators;
